import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Any: any;
  DateTime: any;
  Decimal: any;
};

export type Address = {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  addressRegion?: Maybe<AddressRegion>;
  country?: Maybe<Country>;
  id: Scalars['Int'];
  zipCode?: Maybe<Scalars['String']>;
};

export type AddressRegion = {
  __typename?: 'AddressRegion';
  country?: Maybe<Country>;
  depName?: Maybe<Scalars['String']>;
  depNum?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER'
}

export type ArticleOptimalStockOverride = {
  __typename?: 'ArticleOptimalStockOverride';
  articleId: Scalars['Int'];
  hasCondition: Scalars['Boolean'];
  hasStockMax: Scalars['Boolean'];
  hasStockMin: Scalars['Boolean'];
  id: Scalars['Int'];
  stockMax: Scalars['Int'];
  stockMaxStoreStrengthCondition: Scalars['Int'];
  stockMaxStoreStrengthConditionValue: Scalars['Int'];
  stockMin: Scalars['Int'];
  stockMinStoreStrengthCondition: Scalars['Int'];
  stockMinStoreStrengthConditionValue: Scalars['Int'];
};

export type ArticleSettingDto = {
  __typename?: 'ArticleSettingDto';
  sKU?: Maybe<Scalars['String']>;
  sizeName?: Maybe<Scalars['String']>;
};

export type AuditableInfoDto = {
  __typename?: 'AuditableInfoDto';
  action?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['String']>;
  newValue?: Maybe<Scalars['String']>;
  object?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
  property?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  user?: Maybe<Scalars['String']>;
};

export type AuditableInfoDtoCollectionSegment = {
  __typename?: 'AuditableInfoDtoCollectionSegment';
  items?: Maybe<Array<Maybe<AuditableInfoDto>>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export enum AuditableObjectType {
  Article = 'ARTICLE',
  ArticleOptimalStockException = 'ARTICLE_OPTIMAL_STOCK_EXCEPTION',
  ArticleOptimalStockOverride = 'ARTICLE_OPTIMAL_STOCK_OVERRIDE',
  Collection = 'COLLECTION',
  FamilyToSizeSystem = 'FAMILY_TO_SIZE_SYSTEM',
  Product = 'PRODUCT',
  ProductModule = 'PRODUCT_MODULE',
  SizeSystem = 'SIZE_SYSTEM',
  SizeSystemRow = 'SIZE_SYSTEM_ROW',
  SizeSystemRowHeader = 'SIZE_SYSTEM_ROW_HEADER',
  SizeSystemRowValue = 'SIZE_SYSTEM_ROW_VALUE',
  Store = 'STORE',
  StoreGroup = 'STORE_GROUP',
  StoreGroupToProductModule = 'STORE_GROUP_TO_PRODUCT_MODULE',
  StoreOptimalStockException = 'STORE_OPTIMAL_STOCK_EXCEPTION',
  StoreStrength = 'STORE_STRENGTH',
  StoreStrengthOverride = 'STORE_STRENGTH_OVERRIDE',
  StoreToStoreGroup = 'STORE_TO_STORE_GROUP',
  StoreType = 'STORE_TYPE',
  StoreUniverseInfo = 'STORE_UNIVERSE_INFO',
  TenantSettings = 'TENANT_SETTINGS',
  Warehouse = 'WAREHOUSE'
}

export enum CapacityType {
  NotSet = 'NOT_SET',
  Pieces = 'PIECES',
  SquareMeters = 'SQUARE_METERS'
}

export type Collection = {
  __typename?: 'Collection';
  code?: Maybe<Scalars['String']>;
  combinationType: CombinationType;
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  productModules?: Maybe<Array<Maybe<ProductModule>>>;
  storeGroups?: Maybe<Array<Maybe<StoreGroup>>>;
  universeId: Scalars['Int'];
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
};

export enum CombinationType {
  Exclusive = 'EXCLUSIVE',
  Multiple = 'MULTIPLE'
}

export enum ComparisonSign {
  Equals = 'EQUALS',
  GreaterOrEquals = 'GREATER_OR_EQUALS',
  GreaterThan = 'GREATER_THAN',
  LessOrEquals = 'LESS_OR_EQUALS',
  LessThan = 'LESS_THAN',
  NotEquals = 'NOT_EQUALS'
}

export type Country = {
  __typename?: 'Country';
  alpha3?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type DashboardDto = {
  __typename?: 'DashboardDto';
  exportDate: Scalars['DateTime'];
  exportId: Scalars['Int'];
  importLogs?: Maybe<Array<Maybe<FileImportLog>>>;
  newsletterBody?: Maybe<Scalars['String']>;
  newsletterImgUrl?: Maybe<Scalars['String']>;
  newsletterSubtitle?: Maybe<Scalars['String']>;
  newsletterTitle?: Maybe<Scalars['String']>;
};

export type Department = {
  __typename?: 'Department';
  code?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type ExceptionOptimalStockDto = {
  __typename?: 'ExceptionOptimalStockDto';
  hasExceptions: Scalars['Boolean'];
  isIncluded: Scalars['Boolean'];
  leftTable?: Maybe<Array<Maybe<HeaderValuePair>>>;
  rightTable?: Maybe<Array<Maybe<HeaderValuePair>>>;
  storeCode?: Maybe<Scalars['String']>;
  storeCustomField1?: Maybe<Scalars['String']>;
  storeCustomField2?: Maybe<Scalars['String']>;
  storeCustomField3?: Maybe<Scalars['String']>;
  storeCustomField4?: Maybe<Scalars['String']>;
  storeCustomField5?: Maybe<Scalars['String']>;
  storeGroupName?: Maybe<Scalars['String']>;
  storeId: Scalars['Int'];
  storeName?: Maybe<Scalars['String']>;
  storeStrength: Scalars['Int'];
};

export type ExceptionOptimalStockHeaderDto = {
  __typename?: 'ExceptionOptimalStockHeaderDto';
  articleId?: Maybe<Scalars['Int']>;
  headerId: Scalars['Int'];
  headerName?: Maybe<Scalars['String']>;
};

export type ExceptionOptimalStockRetailStockDto = {
  __typename?: 'ExceptionOptimalStockRetailStockDto';
  articleId?: Maybe<Scalars['Int']>;
  headerId: Scalars['Int'];
  headerName?: Maybe<Scalars['String']>;
  warehouseStockQuantity?: Maybe<Scalars['Int']>;
};

export enum ExceptionOptimalStockSalesEnum {
  EstimationPicking = 'ESTIMATION_PICKING',
  SeasonTotal = 'SEASON_TOTAL',
  StockStore = 'STOCK_STORE',
  StockStoreAndTransit = 'STOCK_STORE_AND_TRANSIT',
  ThreeWeekAverage = 'THREE_WEEK_AVERAGE'
}

export enum ExceptionOptimalStockStockEnum {
  OptimalStock = 'OPTIMAL_STOCK',
  StockStoreAndTransit = 'STOCK_STORE_AND_TRANSIT'
}

export type ExceptionOptimalStockTableDto = {
  __typename?: 'ExceptionOptimalStockTableDto';
  exceptionOptimalStock?: Maybe<Array<Maybe<ExceptionOptimalStockDto>>>;
  numberOfWeeksInSale: Scalars['Int'];
  sizeSystemHeaders?: Maybe<Array<Maybe<ExceptionOptimalStockHeaderDto>>>;
};

export type Family = {
  __typename?: 'Family';
  code?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type FileImportLog = {
  __typename?: 'FileImportLog';
  errors?: Maybe<Scalars['String']>;
  errorsCount: Scalars['Int'];
  id: Scalars['Int'];
  importDate: Scalars['DateTime'];
  isSuccessful: Scalars['Boolean'];
  object?: Maybe<Scalars['String']>;
};

export enum FileImportType {
  IdealStock = 'IDEAL_STOCK',
  ProductColor = 'PRODUCT_COLOR',
  ProductColorSize = 'PRODUCT_COLOR_SIZE',
  ProductColorSizeStore = 'PRODUCT_COLOR_SIZE_STORE',
  ProductColorStore = 'PRODUCT_COLOR_STORE',
  Store = 'STORE',
  StoreSeason = 'STORE_SEASON',
  StoreSeasonPermutationFields = 'STORE_SEASON_PERMUTATION_FIELDS'
}

export enum FileType {
  Csv = 'CSV',
  Excel = 'EXCEL'
}

export type HeaderValuePair = {
  __typename?: 'HeaderValuePair';
  headerId: Scalars['Int'];
  isOverriden: Scalars['Boolean'];
  value: Scalars['Int'];
};

export type MvProduct = {
  __typename?: 'MVProduct';
  /** Lib col */
  colorName?: Maybe<Scalars['String']>;
  /** Famille */
  familyName?: Maybe<Scalars['String']>;
  /** Code */
  productCode?: Maybe<Scalars['String']>;
  productId: Scalars['Int'];
  /** Nom */
  productName?: Maybe<Scalars['String']>;
  /** Tarif */
  productPrice: Scalars['Decimal'];
  /** Ventes période */
  salesPeriod?: Maybe<Scalars['Int']>;
  /** % STK Mag vs STK Total */
  stkStoreVsStkTotal?: Maybe<Scalars['Decimal']>;
  /** STK Mag */
  stockStore?: Maybe<Scalars['Int']>;
  /** Taux Ecoul. Mag */
  storeFlowRate?: Maybe<Scalars['Decimal']>;
  /** Thème */
  theme?: Maybe<Scalars['String']>;
  /** % Taux Ecoul. Total */
  totalFlowRate?: Maybe<Scalars['Decimal']>;
  /** STK Dep */
  warehouseStock?: Maybe<Scalars['Int']>;
};

export enum MaximizationCriterion {
  GainPerSales = 'GAIN_PER_SALES',
  ProfitMargin = 'PROFIT_MARGIN',
  ProfitTurnover = 'PROFIT_TURNOVER'
}

export type OptimalStockDataDto = {
  __typename?: 'OptimalStockDataDto';
  actualStockDemand: Scalars['Int'];
  estimatedPicking: Scalars['Int'];
  optimalStock: Scalars['Int'];
};

export type OptimalStockSimulationDto = {
  __typename?: 'OptimalStockSimulationDto';
  barcode?: Maybe<Scalars['String']>;
  colorCode?: Maybe<Scalars['String']>;
  colorName?: Maybe<Scalars['String']>;
  estimationPicking: Scalars['Int'];
  familyName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  optimalStock: Scalars['Int'];
  permutationField1?: Maybe<Scalars['String']>;
  permutationField2?: Maybe<Scalars['String']>;
  productCode?: Maybe<Scalars['String']>;
  productCustomField1?: Maybe<Scalars['String']>;
  productCustomField2?: Maybe<Scalars['String']>;
  productCustomField3?: Maybe<Scalars['String']>;
  productCustomField4?: Maybe<Scalars['String']>;
  productCustomField5?: Maybe<Scalars['String']>;
  productIsSynced: Scalars['Boolean'];
  productName?: Maybe<Scalars['String']>;
  sizeHeader?: Maybe<Scalars['String']>;
  storeCode?: Maybe<Scalars['String']>;
  storeCustomField1?: Maybe<Scalars['String']>;
  storeCustomField2?: Maybe<Scalars['String']>;
  storeCustomField3?: Maybe<Scalars['String']>;
  storeCustomField4?: Maybe<Scalars['String']>;
  storeCustomField5?: Maybe<Scalars['String']>;
  storeIsSynced: Scalars['Boolean'];
  storeName?: Maybe<Scalars['String']>;
};

export enum OptimalStockSimulationField {
  Barcode = 'BARCODE',
  ColorCode = 'COLOR_CODE',
  ColorName = 'COLOR_NAME',
  EstimationPicking = 'ESTIMATION_PICKING',
  FamilyName = 'FAMILY_NAME',
  OptimalStock = 'OPTIMAL_STOCK',
  PermutationField1 = 'PERMUTATION_FIELD1',
  PermutationField2 = 'PERMUTATION_FIELD2',
  ProductCode = 'PRODUCT_CODE',
  ProductCustomField1 = 'PRODUCT_CUSTOM_FIELD1',
  ProductCustomField2 = 'PRODUCT_CUSTOM_FIELD2',
  ProductCustomField3 = 'PRODUCT_CUSTOM_FIELD3',
  ProductCustomField4 = 'PRODUCT_CUSTOM_FIELD4',
  ProductCustomField5 = 'PRODUCT_CUSTOM_FIELD5',
  ProductIsSynced = 'PRODUCT_IS_SYNCED',
  ProductName = 'PRODUCT_NAME',
  SizeHeader = 'SIZE_HEADER',
  StoreCode = 'STORE_CODE',
  StoreCustomField1 = 'STORE_CUSTOM_FIELD1',
  StoreCustomField2 = 'STORE_CUSTOM_FIELD2',
  StoreCustomField3 = 'STORE_CUSTOM_FIELD3',
  StoreCustomField4 = 'STORE_CUSTOM_FIELD4',
  StoreCustomField5 = 'STORE_CUSTOM_FIELD5',
  StoreIsSynced = 'STORE_IS_SYNCED',
  StoreName = 'STORE_NAME'
}

export type OptimalStockSimulationFilterDtoInput = {
  type?: InputMaybe<OptimalStockSimulationField>;
  value?: InputMaybe<Scalars['String']>;
};

export enum OriginType {
  Imported = 'IMPORTED',
  Web = 'WEB'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
};

export type PaginationInfoOfOptimalStockSimulationDto = {
  __typename?: 'PaginationInfoOfOptimalStockSimulationDto';
  items?: Maybe<Array<Maybe<OptimalStockSimulationDto>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int'];
};

export enum PermissionsEnum {
  ProductPerformanceDetailsEdit = 'PRODUCT_PERFORMANCE_DETAILS_EDIT',
  ProductPerformanceMainTableEdit = 'PRODUCT_PERFORMANCE_MAIN_TABLE_EDIT',
  SettingsEdit = 'SETTINGS_EDIT',
  SettingsGeneralSettingsEdit = 'SETTINGS_GENERAL_SETTINGS_EDIT',
  SettingsGeneralSettingsView = 'SETTINGS_GENERAL_SETTINGS_VIEW',
  SettingsUserManagementEdit = 'SETTINGS_USER_MANAGEMENT_EDIT',
  SettingsUserManagementView = 'SETTINGS_USER_MANAGEMENT_VIEW',
  SettingsView = 'SETTINGS_VIEW',
  StoreFleetMainTableDelete = 'STORE_FLEET_MAIN_TABLE_DELETE',
  StoreFleetMainTableEdit = 'STORE_FLEET_MAIN_TABLE_EDIT',
  StorePerformanceEdit = 'STORE_PERFORMANCE_EDIT'
}

export enum PermutationFieldType {
  CustomField1 = 'CUSTOM_FIELD1',
  CustomField2 = 'CUSTOM_FIELD2',
  CustomField3 = 'CUSTOM_FIELD3',
  CustomField4 = 'CUSTOM_FIELD4',
  CustomField5 = 'CUSTOM_FIELD5',
  Family = 'FAMILY'
}

export enum ProcessStatus {
  Delete = 'DELETE',
  Done = 'DONE',
  Error = 'ERROR',
  Finished = 'FINISHED',
  PostDone = 'POST_DONE',
  Preparation = 'PREPARATION',
  Progress = 'PROGRESS',
  Unknown = 'UNKNOWN',
  Waiting = 'WAITING'
}

export type Product = {
  __typename?: 'Product';
  code?: Maybe<Scalars['String']>;
  colorCode?: Maybe<Scalars['String']>;
  customFieldValue1?: Maybe<Scalars['String']>;
  customFieldValue2?: Maybe<Scalars['String']>;
  customFieldValue3?: Maybe<Scalars['String']>;
  customFieldValue4?: Maybe<Scalars['String']>;
  customFieldValue5?: Maybe<Scalars['String']>;
  familyId: Scalars['Int'];
  id: Scalars['Int'];
  isOnShowcase: Scalars['Boolean'];
  isSynced: Scalars['Boolean'];
  photoUrls?: Maybe<Scalars['String']>;
  price: Scalars['Decimal'];
  productModuleId?: Maybe<Scalars['Int']>;
  seasonId: Scalars['Int'];
  sizeSystemId: Scalars['Int'];
  sizeSystemRowId?: Maybe<Scalars['Int']>;
};

export enum ProductColorImportType {
  ColorCode = 'COLOR_CODE',
  CustomFieldValue_1 = 'CUSTOM_FIELD_VALUE_1',
  CustomFieldValue_2 = 'CUSTOM_FIELD_VALUE_2',
  CustomFieldValue_3 = 'CUSTOM_FIELD_VALUE_3',
  CustomFieldValue_4 = 'CUSTOM_FIELD_VALUE_4',
  CustomFieldValue_5 = 'CUSTOM_FIELD_VALUE_5',
  GenericReference = 'GENERIC_REFERENCE',
  HasCondition = 'HAS_CONDITION',
  HasStockMax = 'HAS_STOCK_MAX',
  HasStockMin = 'HAS_STOCK_MIN',
  IsOnShowcase = 'IS_ON_SHOWCASE',
  IsSync = 'IS_SYNC',
  NewSeasonCode = 'NEW_SEASON_CODE',
  ProductCode = 'PRODUCT_CODE',
  ProductModuleName = 'PRODUCT_MODULE_NAME',
  ProductStrength = 'PRODUCT_STRENGTH',
  SeasonCode = 'SEASON_CODE',
  SizeSystemRowName = 'SIZE_SYSTEM_ROW_NAME',
  StockMaxStoreStrengthCondition = 'STOCK_MAX_STORE_STRENGTH_CONDITION',
  StockMinStoreStrengthCondition = 'STOCK_MIN_STORE_STRENGTH_CONDITION'
}

export enum ProductColorSizeImportType {
  ColorCode = 'COLOR_CODE',
  ProductCode = 'PRODUCT_CODE',
  SeasonCode = 'SEASON_CODE',
  SizeSystemHeaderName = 'SIZE_SYSTEM_HEADER_NAME',
  StockMaxStoreStrengthConditionValue = 'STOCK_MAX_STORE_STRENGTH_CONDITION_VALUE',
  StockMaxValue = 'STOCK_MAX_VALUE',
  StockMinStoreStrengthConditionValue = 'STOCK_MIN_STORE_STRENGTH_CONDITION_VALUE',
  StockMinValue = 'STOCK_MIN_VALUE'
}

export enum ProductColorSizeStoreImportType {
  ArticleOptimalStockException = 'ARTICLE_OPTIMAL_STOCK_EXCEPTION',
  ColorCode = 'COLOR_CODE',
  ProductCode = 'PRODUCT_CODE',
  SeasonCode = 'SEASON_CODE',
  SizeSystemHeaderName = 'SIZE_SYSTEM_HEADER_NAME',
  StoreCode = 'STORE_CODE',
  UniverseCode = 'UNIVERSE_CODE'
}

export enum ProductColorStoreImportType {
  ColorCode = 'COLOR_CODE',
  ProductCode = 'PRODUCT_CODE',
  SeasonCode = 'SEASON_CODE',
  StoreAction = 'STORE_ACTION',
  StoreCode = 'STORE_CODE',
  UniverseCode = 'UNIVERSE_CODE'
}

export type ProductCustomFieldsDto = {
  __typename?: 'ProductCustomFieldsDto';
  customFieldName1?: Maybe<Scalars['String']>;
  customFieldName2?: Maybe<Scalars['String']>;
  customFieldName3?: Maybe<Scalars['String']>;
  customFieldName4?: Maybe<Scalars['String']>;
  customFieldName5?: Maybe<Scalars['String']>;
  customFieldValues1?: Maybe<Scalars['String']>;
  customFieldValues2?: Maybe<Scalars['String']>;
  customFieldValues3?: Maybe<Scalars['String']>;
  customFieldValues4?: Maybe<Scalars['String']>;
  customFieldValues5?: Maybe<Scalars['String']>;
};

export type ProductDetailsDto = {
  __typename?: 'ProductDetailsDto';
  collectionId: Scalars['Int'];
  customFieldValue1?: Maybe<Scalars['String']>;
  customFieldValue2?: Maybe<Scalars['String']>;
  customFieldValue3?: Maybe<Scalars['String']>;
  customFieldValue4?: Maybe<Scalars['String']>;
  customFieldValue5?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  isOnShowcase: Scalars['Boolean'];
  isSynced: Scalars['Boolean'];
  photoUrls?: Maybe<Scalars['String']>;
  price: Scalars['Decimal'];
  productModuleId?: Maybe<Scalars['Int']>;
  seasonId: Scalars['Int'];
  sizeSystemId: Scalars['Int'];
  sizeSystemRowId?: Maybe<Scalars['Int']>;
  universeId?: Maybe<Scalars['Int']>;
  validatedStrength: Scalars['Decimal'];
};

export type ProductFleetPerformanceDto = {
  __typename?: 'ProductFleetPerformanceDto';
  averagePastThreeWeeksSalesAllStores: Scalars['Int'];
  collectionName?: Maybe<Scalars['String']>;
  colorCode?: Maybe<Scalars['String']>;
  colorName?: Maybe<Scalars['String']>;
  customFieldValue1?: Maybe<Scalars['String']>;
  customFieldValue2?: Maybe<Scalars['String']>;
  customFieldValue3?: Maybe<Scalars['String']>;
  customFieldValue4?: Maybe<Scalars['String']>;
  customFieldValue5?: Maybe<Scalars['String']>;
  estimationPicking: Scalars['Int'];
  excludedStoreExceptionsCount: Scalars['Int'];
  familyName?: Maybe<Scalars['String']>;
  hasCondition: Scalars['Boolean'];
  hasException: Scalars['Boolean'];
  hasStockMaxOverride: Scalars['Boolean'];
  hasStockMinOverride: Scalars['Boolean'];
  id: Scalars['Int'];
  implantedStrength: Scalars['Int'];
  includedStoreExceptionsCount: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  isOnShowcase: Scalars['Boolean'];
  isSynced: Scalars['Boolean'];
  numberOfStoresInWhichProductIsPresent: Scalars['Int'];
  numberOfWeeksTheProductIsSold: Scalars['Int'];
  optimalStock: Scalars['Int'];
  optimalStockPastWeek: Scalars['Int'];
  pastThreeWeekSales: Scalars['Int'];
  pastTwoWeekSales: Scalars['Int'];
  pastWeekSales: Scalars['Int'];
  permutationField1?: Maybe<Scalars['String']>;
  permutationField2?: Maybe<Scalars['String']>;
  photoUrls?: Maybe<Scalars['String']>;
  physicalStoreSales: Scalars['Int'];
  potentialSalesPastWeekAllStores: Scalars['Decimal'];
  potentialWeeklySalesFlow: Scalars['Decimal'];
  productCode?: Maybe<Scalars['String']>;
  productModuleName?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  proposedStrength: Scalars['Decimal'];
  quantityForDelivery: Scalars['Int'];
  quantityInTransit: Scalars['Int'];
  quantityPicking: Scalars['Int'];
  salesPrice: Scalars['Decimal'];
  sizeSystemName?: Maybe<Scalars['String']>;
  sizeSystemRowName?: Maybe<Scalars['String']>;
  stockFlowRate: Scalars['Decimal'];
  stockQuantityInPhysicalStore: Scalars['Int'];
  stockQuantityInWebStore: Scalars['Int'];
  stockQuantityTotal: Scalars['Int'];
  stockTotal: Scalars['Int'];
  stockWarehouse: Scalars['Int'];
  totalQuantitySold: Scalars['Int'];
  validatedStrength: Scalars['Decimal'];
  warehouseCoverage: Scalars['Int'];
  warehouseStockRetails: Scalars['Int'];
  warehouseStockWholesale: Scalars['Int'];
  webPercent: Scalars['Decimal'];
  webStoreSales: Scalars['Int'];
  weekDiscountStockRate: Scalars['Int'];
  weekSales: Scalars['Int'];
};

export type ProductModule = {
  __typename?: 'ProductModule';
  collectionId: Scalars['Int'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  storeGroupToProductModules?: Maybe<Array<Maybe<StoreGroupToProductModule>>>;
  universeId: Scalars['Int'];
};

export type ProductOptimalSalesTableColumnDto = {
  __typename?: 'ProductOptimalSalesTableColumnDto';
  allWeeksTotal: Scalars['Int'];
  distribution: Scalars['Int'];
  physicalSales: Scalars['Int'];
  remainingQuantitiesByDateAndSupplier?: Maybe<Array<Maybe<StatisticsSupplierOptimalStockDto>>>;
  remainingQuantity: Scalars['Int'];
  sKU?: Maybe<Scalars['String']>;
  salesFifthWeek: Scalars['Int'];
  salesFirstWeek: Scalars['Int'];
  salesFourthWeek: Scalars['Int'];
  salesSecondWeek: Scalars['Int'];
  salesThirdWeek: Scalars['Int'];
  sizeSystemRowHeaderId: Scalars['Int'];
  sizeSystemRowHeaderName?: Maybe<Scalars['String']>;
  stockAvailableAndInTransit: Scalars['Int'];
  stockQuantityPicking: Scalars['Int'];
  totalSales: Scalars['Int'];
  warehouseQuantity: Scalars['Int'];
  webSales: Scalars['Int'];
};

export type ProductOptimalSalesTableDto = {
  __typename?: 'ProductOptimalSalesTableDto';
  columns?: Maybe<Array<Maybe<ProductOptimalSalesTableColumnDto>>>;
  discountColumn?: Maybe<ProductOptimalStockSalesTableDiscountColumnDto>;
  headers?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ProductOptimalStockHeaderDto = {
  __typename?: 'ProductOptimalStockHeaderDto';
  id: Scalars['Int'];
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  optimalStockOverrideId?: Maybe<Scalars['Int']>;
};

export type ProductOptimalStockMetadata = {
  __typename?: 'ProductOptimalStockMetadata';
  isOnShowcase: Scalars['Boolean'];
  numberOfStores: Scalars['Int'];
  numberOfStoresWithShowcase: Scalars['Int'];
  proposedStrength: Scalars['Decimal'];
  theoreticalSalesFlow: Scalars['Decimal'];
  validatedProductStrength: Scalars['Decimal'];
  weeklySalesFlow: Scalars['Decimal'];
};

export type ProductOptimalStockSalesTableDiscountColumnDto = {
  __typename?: 'ProductOptimalStockSalesTableDiscountColumnDto';
  discountStockRateFifthWeek: Scalars['Int'];
  discountStockRateFirstWeek: Scalars['Int'];
  discountStockRateFourthWeek: Scalars['Int'];
  discountStockRatePerFiveWeeks: Scalars['Int'];
  discountStockRatePerPhysical: Scalars['Int'];
  discountStockRatePerSeason: Scalars['Int'];
  discountStockRatePerWeb: Scalars['Int'];
  discountStockRateSecondWeek: Scalars['Int'];
  discountStockRateThirdWeek: Scalars['Int'];
};

export type ProductOptimalStockSummaryDto = {
  __typename?: 'ProductOptimalStockSummaryDto';
  collectionId: Scalars['Int'];
  colorCode?: Maybe<Scalars['String']>;
  colorName?: Maybe<Scalars['String']>;
  customFieldValue1?: Maybe<Scalars['String']>;
  customFieldValue2?: Maybe<Scalars['String']>;
  customFieldValue3?: Maybe<Scalars['String']>;
  customFieldValue4?: Maybe<Scalars['String']>;
  customFieldValue5?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isArchived: Scalars['Boolean'];
  permutationField1?: Maybe<Scalars['String']>;
  permutationField2?: Maybe<Scalars['String']>;
  photoUrls?: Maybe<Scalars['String']>;
  price: Scalars['Decimal'];
  productCode?: Maybe<Scalars['String']>;
  productModuleId?: Maybe<Scalars['Int']>;
  productName?: Maybe<Scalars['String']>;
  sizeSystemId: Scalars['Int'];
  sizeSystemName?: Maybe<Scalars['String']>;
  sizeSystemRowId?: Maybe<Scalars['Int']>;
  sizeSystemRowName?: Maybe<Scalars['String']>;
};

export type ProductOptimalStockTableRowDto = {
  __typename?: 'ProductOptimalStockTableRowDto';
  numberOfStores: Scalars['Int'];
  optimalStock?: Maybe<Array<Maybe<Scalars['Int']>>>;
  storeStrength: Scalars['Int'];
  total: Scalars['Int'];
};

export type ProductOptimalStockTableWrapperDto = {
  __typename?: 'ProductOptimalStockTableWrapperDto';
  headers?: Maybe<Array<Maybe<ProductOptimalStockHeaderDto>>>;
  metadata?: Maybe<ProductOptimalStockMetadata>;
  overrides?: Maybe<Array<Maybe<ArticleOptimalStockOverride>>>;
  rows?: Maybe<Array<Maybe<ProductOptimalStockTableRowDto>>>;
  summary?: Maybe<Array<Maybe<OptimalStockDataDto>>>;
};

export type ProductSettingsDto = {
  __typename?: 'ProductSettingsDto';
  articles?: Maybe<Array<Maybe<ArticleSettingDto>>>;
  code?: Maybe<Scalars['String']>;
  colorCode?: Maybe<Scalars['String']>;
  colorName?: Maybe<Scalars['String']>;
  costPrice: Scalars['Decimal'];
  customFieldValue1?: Maybe<Scalars['String']>;
  customFieldValue2?: Maybe<Scalars['String']>;
  customFieldValue3?: Maybe<Scalars['String']>;
  customFieldValue4?: Maybe<Scalars['String']>;
  customFieldValue5?: Maybe<Scalars['String']>;
  departmentName?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  genericReference?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price: Scalars['Decimal'];
  seasonName?: Maybe<Scalars['String']>;
  subFamilyName?: Maybe<Scalars['String']>;
  universeName?: Maybe<Scalars['String']>;
};

export enum ReferencyColor {
  Complete = 'COMPLETE',
  SizeOnly = 'SIZE_ONLY'
}

export enum ReferencyTransfert {
  Both = 'BOTH',
  InterStore = 'INTER_STORE',
  ReturnWarehouse = 'RETURN_WAREHOUSE'
}

export type RefreshViewsStatus = {
  __typename?: 'RefreshViewsStatus';
  /** In Progress */
  inProgress: Scalars['Boolean'];
  /** Refresh Date */
  refreshDate?: Maybe<Scalars['DateTime']>;
  /** Trigger Refresh Date */
  triggerRefreshDate: Scalars['DateTime'];
};

export enum SalePeriod {
  Accumulation = 'ACCUMULATION',
  FromDate = 'FROM_DATE'
}

export type Season = {
  __typename?: 'Season';
  code?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
};

export type SenderReceiver = {
  __typename?: 'SenderReceiver';
  code?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type SimulationDto = {
  __typename?: 'SimulationDto';
  processId?: Maybe<Scalars['String']>;
  processProgress: Scalars['Int'];
  processStatus?: Maybe<ProcessStatus>;
};

export type SizeSystem = {
  __typename?: 'SizeSystem';
  code?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  origin: OriginType;
  sizeSystemRowHeaders?: Maybe<Array<Maybe<SizeSystemRowHeader>>>;
  sizeSystemRows?: Maybe<Array<Maybe<SizeSystemRow>>>;
};

export type SizeSystemRow = {
  __typename?: 'SizeSystemRow';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  sizeSystemRowValues?: Maybe<Array<Maybe<SizeSystemRowValue>>>;
  sortNumber: Scalars['Int'];
};

export type SizeSystemRowHeader = {
  __typename?: 'SizeSystemRowHeader';
  id: Scalars['Int'];
  isOnShowcase: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  sortNumber: Scalars['Int'];
};

export type SizeSystemRowValue = {
  __typename?: 'SizeSystemRowValue';
  distribution: Scalars['Int'];
  id: Scalars['Int'];
  sizeSystemRowHeaderId: Scalars['Int'];
  sizeSystemRowId: Scalars['Int'];
};

export type StatisticsSupplierOptimalStockDto = {
  __typename?: 'StatisticsSupplierOptimalStockDto';
  quantityForDelivery: Scalars['Int'];
  supplierCode?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
};

export type Store = {
  __typename?: 'Store';
  address?: Maybe<Address>;
  code?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  storeType?: Maybe<StoreType>;
};

export type StoreActiveStateInput = {
  isActive: Scalars['Boolean'];
  storeId: Scalars['Int'];
  universeId: Scalars['Int'];
};

export type StoreCustomFieldsDto = {
  __typename?: 'StoreCustomFieldsDto';
  customFieldName1?: Maybe<Scalars['String']>;
  customFieldName2?: Maybe<Scalars['String']>;
  customFieldName3?: Maybe<Scalars['String']>;
  customFieldName4?: Maybe<Scalars['String']>;
  customFieldName5?: Maybe<Scalars['String']>;
  customFieldValues1?: Maybe<Scalars['String']>;
  customFieldValues2?: Maybe<Scalars['String']>;
  customFieldValues3?: Maybe<Scalars['String']>;
  customFieldValues4?: Maybe<Scalars['String']>;
  customFieldValues5?: Maybe<Scalars['String']>;
};

export type StoreDetailsDto = {
  __typename?: 'StoreDetailsDto';
  capacity: Scalars['Int'];
  capacityType?: Maybe<CapacityType>;
  code?: Maybe<Scalars['String']>;
  customFieldValue1?: Maybe<Scalars['String']>;
  customFieldValue2?: Maybe<Scalars['String']>;
  customFieldValue3?: Maybe<Scalars['String']>;
  customFieldValue4?: Maybe<Scalars['String']>;
  customFieldValue5?: Maybe<Scalars['String']>;
  handlesShowcase: Scalars['Boolean'];
  id: Scalars['Int'];
  ignoreMinMax: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  isSynced: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  originType?: Maybe<OriginType>;
  photoUrls?: Maybe<Scalars['String']>;
  pickingPriority: Scalars['Int'];
  regionId?: Maybe<Scalars['Int']>;
  regionName?: Maybe<Scalars['String']>;
  storeTypeId?: Maybe<Scalars['Int']>;
};

export type StoreFleetCollectionDto = {
  __typename?: 'StoreFleetCollectionDto';
  collectionId: Scalars['Int'];
  storeGroupId: Scalars['Int'];
  storeGroupName?: Maybe<Scalars['String']>;
};

export type StoreFleetDto = {
  __typename?: 'StoreFleetDto';
  capacity: Scalars['Int'];
  capacityRatio: Scalars['Decimal'];
  handlesShowcase: Scalars['Boolean'];
  id: Scalars['Int'];
  ignoreMinMax: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  isSynced: Scalars['Boolean'];
  pickingPriority: Scalars['Int'];
  storeCode?: Maybe<Scalars['String']>;
  storeCustomField1?: Maybe<Scalars['String']>;
  storeCustomField2?: Maybe<Scalars['String']>;
  storeCustomField3?: Maybe<Scalars['String']>;
  storeCustomField4?: Maybe<Scalars['String']>;
  storeCustomField5?: Maybe<Scalars['String']>;
  storeName?: Maybe<Scalars['String']>;
  storeRegion?: Maybe<Scalars['String']>;
  storeStrength: Scalars['Decimal'];
  storeStrengthImplant: Scalars['Decimal'];
  storeToStoreGroups?: Maybe<Array<Maybe<StoreFleetCollectionDto>>>;
  storeType?: Maybe<Scalars['String']>;
  targetTurnover: Scalars['Decimal'];
};

export type StoreFleetSummaryStoreGroupsDto = {
  __typename?: 'StoreFleetSummaryStoreGroupsDto';
  groupName?: Maybe<Scalars['String']>;
  numberOfStores: Scalars['Int'];
  storesTargetTurnover: Scalars['Decimal'];
};

export type StoreFleetSummaryStorePerformanceDto = {
  __typename?: 'StoreFleetSummaryStorePerformanceDto';
  percentageOfTotal: Scalars['Decimal'];
  storePerformance: Scalars['Decimal'];
  storePerformanceStoreCount: Scalars['Int'];
};

export type StoreFleetSummaryTableDto = {
  __typename?: 'StoreFleetSummaryTableDto';
  storePerformanceTable?: Maybe<Array<Maybe<StoreFleetSummaryStorePerformanceDto>>>;
  targetTurnoverTable?: Maybe<Array<Maybe<StoreFleetSummaryTargetTurnoverDto>>>;
};

export type StoreFleetSummaryTargetTurnoverDto = {
  __typename?: 'StoreFleetSummaryTargetTurnoverDto';
  collectionName?: Maybe<Scalars['String']>;
  storeGroups?: Maybe<Array<Maybe<StoreFleetSummaryStoreGroupsDto>>>;
};

export type StoreGroup = {
  __typename?: 'StoreGroup';
  collectionId: Scalars['Int'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  storeGroupToProductModules?: Maybe<Array<Maybe<StoreGroupToProductModule>>>;
  universeId: Scalars['Int'];
};

export type StoreGroupToProductModule = {
  __typename?: 'StoreGroupToProductModule';
  id: Scalars['Int'];
  isSelected: Scalars['Boolean'];
  productModuleId: Scalars['Int'];
  storeGroupId: Scalars['Int'];
};

export enum StoreImportType {
  CustomFieldValue_1 = 'CUSTOM_FIELD_VALUE_1',
  CustomFieldValue_2 = 'CUSTOM_FIELD_VALUE_2',
  CustomFieldValue_3 = 'CUSTOM_FIELD_VALUE_3',
  CustomFieldValue_4 = 'CUSTOM_FIELD_VALUE_4',
  CustomFieldValue_5 = 'CUSTOM_FIELD_VALUE_5',
  HandleShowcase = 'HANDLE_SHOWCASE',
  IsActive = 'IS_ACTIVE',
  PickingPriority = 'PICKING_PRIORITY',
  StoreCode = 'STORE_CODE',
  StoreType = 'STORE_TYPE',
  UniverseCode = 'UNIVERSE_CODE'
}

export type StoreOptimalStockExceptionDto = {
  __typename?: 'StoreOptimalStockExceptionDto';
  storeCode?: Maybe<Scalars['String']>;
  storeGroupId: Scalars['Int'];
  storeGroupName?: Maybe<Scalars['String']>;
  storeId: Scalars['Int'];
  storeName?: Maybe<Scalars['String']>;
  storeStrength: Scalars['Decimal'];
};

export type StorePerformanceDto = {
  __typename?: 'StorePerformanceDto';
  averageCoverage: Scalars['Int'];
  capacity: Scalars['Int'];
  capacityRatio: Scalars['Decimal'];
  code?: Maybe<Scalars['String']>;
  coverageOneWeekBefore: Scalars['Int'];
  coverageThreeWeeksBefore: Scalars['Int'];
  coverageTwoWeeksBefore: Scalars['Int'];
  customField1?: Maybe<Scalars['String']>;
  customField2?: Maybe<Scalars['String']>;
  customField3?: Maybe<Scalars['String']>;
  customField4?: Maybe<Scalars['String']>;
  customField5?: Maybe<Scalars['String']>;
  estimatedPicking: Scalars['Int'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  numberOfProductsWithOptimalStock: Scalars['Int'];
  numberOfProductsWithSalesLastWeek: Scalars['Int'];
  numberOfProductsWithStock: Scalars['Int'];
  optimalStock: Scalars['Int'];
  optimalStockOneWeekBefore: Scalars['Int'];
  permutationFieldId1?: Maybe<Scalars['String']>;
  permutationFieldId2?: Maybe<Scalars['String']>;
  permutationLabel1?: Maybe<Scalars['String']>;
  permutationLabel2?: Maybe<Scalars['String']>;
  salesQuantityLastWeek: Scalars['Int'];
  stockQuantityLastWeek: Scalars['Int'];
  storeStrengthPerPermutationHistory: Scalars['Int'];
  storeStrengthPerPermutationImplemented: Scalars['Decimal'];
  storeStrengthPerPermutationProposed: Scalars['Int'];
  storeStrengthPerPermutationValidated: Scalars['Int'];
  storeToStoreGroups?: Maybe<Array<Maybe<StoreFleetCollectionDto>>>;
};

export type StorePerformancePermutationSummaryDto = {
  __typename?: 'StorePerformancePermutationSummaryDto';
  averageCoverage: Scalars['Int'];
  coverageOneWeekBefore: Scalars['Int'];
  coverageThreeWeeksBefore: Scalars['Int'];
  coverageTwoWeeksBefore: Scalars['Int'];
  estimatedPicking: Scalars['Int'];
  numberOfProductsWithOptimalStock: Scalars['Int'];
  numberOfProductsWithSalesLastWeek: Scalars['Int'];
  numberOfProductsWithStock: Scalars['Int'];
  optimalStock: Scalars['Int'];
  optimalStockOneWeekBefore: Scalars['Int'];
  permutationField1?: Maybe<Scalars['String']>;
  permutationField2?: Maybe<Scalars['String']>;
  permutationFieldLabel1?: Maybe<Scalars['String']>;
  permutationFieldLabel2?: Maybe<Scalars['String']>;
  salesQuantityLastWeek: Scalars['Int'];
  stockQuantityLastWeek: Scalars['Int'];
};

export type StorePerformanceStoreSummaryDto = {
  __typename?: 'StorePerformanceStoreSummaryDto';
  averageCoverage: Scalars['Int'];
  capacity: Scalars['Int'];
  capacityRatio: Scalars['Decimal'];
  code?: Maybe<Scalars['String']>;
  coverageOneWeekBefore: Scalars['Int'];
  coverageThreeWeeksBefore: Scalars['Int'];
  coverageTwoWeeksBefore: Scalars['Int'];
  customField1?: Maybe<Scalars['String']>;
  customField2?: Maybe<Scalars['String']>;
  customField3?: Maybe<Scalars['String']>;
  customField4?: Maybe<Scalars['String']>;
  customField5?: Maybe<Scalars['String']>;
  estimatedPicking: Scalars['Int'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  numberOfProductsWithOptimalStock: Scalars['Int'];
  numberOfProductsWithSalesLastWeek: Scalars['Int'];
  numberOfProductsWithStock: Scalars['Int'];
  optimalStock: Scalars['Int'];
  optimalStockOneWeekBefore: Scalars['Int'];
  salesQuantityLastWeek: Scalars['Int'];
  stockQuantityLastWeek: Scalars['Int'];
  storeToStoreGroups?: Maybe<Array<Maybe<StoreFleetCollectionDto>>>;
};

export enum StoreSeasonImportType {
  Capacity = 'CAPACITY',
  IgnoreMinMax = 'IGNORE_MIN_MAX',
  IsSynced = 'IS_SYNCED',
  SeasonCode = 'SEASON_CODE',
  StoreCode = 'STORE_CODE',
  StoreGroupName = 'STORE_GROUP_NAME',
  TargetTurnover = 'TARGET_TURNOVER',
  UniverseCode = 'UNIVERSE_CODE'
}

export enum StoreSeasonPermutationFieldsImportType {
  PermutationFields = 'PERMUTATION_FIELDS',
  SeasonCode = 'SEASON_CODE',
  StoreCode = 'STORE_CODE',
  UniverseCode = 'UNIVERSE_CODE',
  ValidatedStrength = 'VALIDATED_STRENGTH'
}

export type StoreSenderReceiverListDto = {
  __typename?: 'StoreSenderReceiverListDto';
  receivers?: Maybe<Array<Maybe<SenderReceiver>>>;
  receiversCount: Scalars['Int'];
  senders?: Maybe<Array<Maybe<SenderReceiver>>>;
  sendersCount: Scalars['Int'];
};

export type StoreSettingDto = {
  __typename?: 'StoreSettingDto';
  address?: Maybe<Address>;
  code?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  targetTurnOver?: Maybe<Scalars['Decimal']>;
  type?: Maybe<Scalars['String']>;
};

export type StoreType = {
  __typename?: 'StoreType';
  code?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isMain: Scalars['Boolean'];
  isWeb: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
};

export type SubFamily = {
  __typename?: 'SubFamily';
  code?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type SwitchConfig = {
  __typename?: 'SwitchConfig';
  carbonFootprintBonus?: Maybe<Scalars['Boolean']>;
  createAt: Scalars['DateTime'];
  editedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  interCountry?: Maybe<Scalars['Boolean']>;
  interRegion?: Maybe<Scalars['Boolean']>;
  maximizationCriterion?: Maybe<MaximizationCriterion>;
  name?: Maybe<Scalars['String']>;
  nbDestMax?: Maybe<Scalars['Int']>;
  nbItemMaxReceiver?: Maybe<Scalars['Int']>;
  nbItemMaxTransfer?: Maybe<Scalars['Int']>;
  nbItemMin?: Maybe<Scalars['Int']>;
  perfDestQtyPeriodSale?: Maybe<Scalars['Int']>;
  perfDestQtyPeriodSaleSign?: Maybe<ComparisonSign>;
  perfExpFlowRatePercent?: Maybe<Scalars['Int']>;
  perfExpFlowRateSign?: Maybe<ComparisonSign>;
  perfExpPresenceMin?: Maybe<Scalars['Int']>;
  perfExpQtyPeriodSale?: Maybe<Scalars['Int']>;
  perfExpQtyPeriodSaleSign?: Maybe<ComparisonSign>;
  perfIdealStock?: Maybe<Scalars['Boolean']>;
  perfIdealStockSender?: Maybe<Scalars['Boolean']>;
  pinned?: Maybe<Scalars['Boolean']>;
  productCouv?: Maybe<WarehouseStock>;
  productCouvSign?: Maybe<ComparisonSign>;
  productCustomField1Values?: Maybe<Array<Maybe<Scalars['String']>>>;
  productCustomField2Values?: Maybe<Array<Maybe<Scalars['String']>>>;
  productCustomField3Values?: Maybe<Array<Maybe<Scalars['String']>>>;
  productCustomField4Values?: Maybe<Array<Maybe<Scalars['String']>>>;
  productCustomField5Values?: Maybe<Array<Maybe<Scalars['String']>>>;
  productDepartments?: Maybe<Array<Maybe<Department>>>;
  productExcludes?: Maybe<Array<Maybe<Product>>>;
  productFamilies?: Maybe<Array<Maybe<Family>>>;
  productFromPeriod?: Maybe<Scalars['DateTime']>;
  productInStoreNbWeeks?: Maybe<Scalars['Int']>;
  productInStoreSign?: Maybe<ComparisonSign>;
  productMarkDownPercent?: Maybe<Scalars['Int']>;
  productMarkDownPeriodSign?: Maybe<ComparisonSign>;
  productMinimumPrice?: Maybe<Scalars['Int']>;
  productNbItem?: Maybe<Scalars['Int']>;
  productNbWeek?: Maybe<Scalars['Int']>;
  productQtyPeriodNbItem?: Maybe<Scalars['Int']>;
  productQtyPeriodSign?: Maybe<ComparisonSign>;
  productRestockNbWeeks?: Maybe<Scalars['Int']>;
  productSalePeriod?: Maybe<SalePeriod>;
  productSeasons?: Maybe<Array<Maybe<Season>>>;
  productSize?: Maybe<WarehouseStock>;
  productSizeSign?: Maybe<ComparisonSign>;
  productSubFamilies?: Maybe<Array<Maybe<SubFamily>>>;
  referencyColor?: Maybe<ReferencyColor>;
  referencyTransfert?: Maybe<ReferencyTransfert>;
  saved?: Maybe<Scalars['Boolean']>;
  storeCountries?: Maybe<Array<Maybe<Country>>>;
  storeCustomField1Values?: Maybe<Array<Maybe<Scalars['String']>>>;
  storeCustomField2Values?: Maybe<Array<Maybe<Scalars['String']>>>;
  storeCustomField3Values?: Maybe<Array<Maybe<Scalars['String']>>>;
  storeCustomField4Values?: Maybe<Array<Maybe<Scalars['String']>>>;
  storeCustomField5Values?: Maybe<Array<Maybe<Scalars['String']>>>;
  storeRecipientExcludes?: Maybe<Array<Maybe<Store>>>;
  storeRegions?: Maybe<Array<Maybe<AddressRegion>>>;
  storeSenderExcludes?: Maybe<Array<Maybe<Store>>>;
  storeTypes?: Maybe<Array<Maybe<StoreType>>>;
  universe?: Maybe<Universe>;
};

export type SwitchConfigFormDto = {
  __typename?: 'SwitchConfigFormDto';
  carbonFootprintBonus?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  interCountry?: Maybe<Scalars['Boolean']>;
  interRegion?: Maybe<Scalars['Boolean']>;
  maximizationCriterion?: Maybe<MaximizationCriterion>;
  name?: Maybe<Scalars['String']>;
  nbDestMax?: Maybe<Scalars['Int']>;
  nbItemMaxReceiver?: Maybe<Scalars['Int']>;
  nbItemMaxTransfer?: Maybe<Scalars['Int']>;
  nbItemMin?: Maybe<Scalars['Int']>;
  perfDestFlowRatePercent?: Maybe<Scalars['Int']>;
  perfDestFlowRateSign?: Maybe<ComparisonSign>;
  perfDestQtyPeriodSale?: Maybe<Scalars['Int']>;
  perfDestQtyPeriodSaleSign?: Maybe<ComparisonSign>;
  perfExpFlowRatePercent?: Maybe<Scalars['Int']>;
  perfExpFlowRateSign?: Maybe<ComparisonSign>;
  perfExpPresenceMin?: Maybe<Scalars['Int']>;
  perfExpQtyPeriodSale?: Maybe<Scalars['Int']>;
  perfExpQtyPeriodSaleSign?: Maybe<ComparisonSign>;
  perfIdealStock?: Maybe<Scalars['Boolean']>;
  perfIdealStockSender?: Maybe<Scalars['Boolean']>;
  pinned?: Maybe<Scalars['Boolean']>;
  productCouv?: Maybe<WarehouseStock>;
  productCouvSign?: Maybe<ComparisonSign>;
  productCustomField1Values?: Maybe<Array<Maybe<Scalars['String']>>>;
  productCustomField2Values?: Maybe<Array<Maybe<Scalars['String']>>>;
  productCustomField3Values?: Maybe<Array<Maybe<Scalars['String']>>>;
  productCustomField4Values?: Maybe<Array<Maybe<Scalars['String']>>>;
  productCustomField5Values?: Maybe<Array<Maybe<Scalars['String']>>>;
  productDepartmentIds?: Maybe<Array<Scalars['Int']>>;
  productExcludesIds?: Maybe<Array<Scalars['Int']>>;
  productFamilyIds?: Maybe<Array<Scalars['Int']>>;
  productFromPeriod?: Maybe<Scalars['DateTime']>;
  productInStoreNbWeeks?: Maybe<Scalars['Int']>;
  productInStoreSign?: Maybe<ComparisonSign>;
  productMarkDownPercent?: Maybe<Scalars['Int']>;
  productMarkDownPeriodSign?: Maybe<ComparisonSign>;
  productMinimumPrice?: Maybe<Scalars['Int']>;
  productNbItem?: Maybe<Scalars['Int']>;
  productNbWeek?: Maybe<Scalars['Int']>;
  productQtyPeriodNbItem?: Maybe<Scalars['Int']>;
  productQtyPeriodSign?: Maybe<ComparisonSign>;
  productRestockNbWeeks?: Maybe<Scalars['Int']>;
  productSalePeriod?: Maybe<SalePeriod>;
  productSeasonsIds?: Maybe<Array<Scalars['Int']>>;
  productSize?: Maybe<WarehouseStock>;
  productSizeSign?: Maybe<ComparisonSign>;
  productSubFamilyIds?: Maybe<Array<Scalars['Int']>>;
  referencyColor?: Maybe<ReferencyColor>;
  referencyTransfert?: Maybe<ReferencyTransfert>;
  saved?: Maybe<Scalars['Boolean']>;
  storeCountriesIds?: Maybe<Array<Scalars['Int']>>;
  storeCustomField1Values?: Maybe<Array<Maybe<Scalars['String']>>>;
  storeCustomField2Values?: Maybe<Array<Maybe<Scalars['String']>>>;
  storeCustomField3Values?: Maybe<Array<Maybe<Scalars['String']>>>;
  storeCustomField4Values?: Maybe<Array<Maybe<Scalars['String']>>>;
  storeCustomField5Values?: Maybe<Array<Maybe<Scalars['String']>>>;
  storeRecipientExcludesIds?: Maybe<Array<Scalars['Int']>>;
  storeRegionsIds?: Maybe<Array<Scalars['Int']>>;
  storeSenderExcludesIds?: Maybe<Array<Scalars['Int']>>;
  storeTypesIds?: Maybe<Array<Scalars['Int']>>;
  universeId: Scalars['Int'];
};

export type SwitchConfigFormInput = {
  carbonFootprintBonus?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  interCountry?: InputMaybe<Scalars['Boolean']>;
  interRegion?: InputMaybe<Scalars['Boolean']>;
  maximizationCriterion?: InputMaybe<MaximizationCriterion>;
  name?: InputMaybe<Scalars['String']>;
  nbDestMax?: InputMaybe<Scalars['Int']>;
  nbItemMaxReceiver?: InputMaybe<Scalars['Int']>;
  nbItemMaxTransfer?: InputMaybe<Scalars['Int']>;
  nbItemMin?: InputMaybe<Scalars['Int']>;
  perfDestFlowRatePercent?: InputMaybe<Scalars['Int']>;
  perfDestFlowRateSign?: InputMaybe<ComparisonSign>;
  perfDestQtyPeriodSale?: InputMaybe<Scalars['Int']>;
  perfDestQtyPeriodSaleSign?: InputMaybe<ComparisonSign>;
  perfExpFlowRatePercent?: InputMaybe<Scalars['Int']>;
  perfExpFlowRateSign?: InputMaybe<ComparisonSign>;
  perfExpPresenceMin?: InputMaybe<Scalars['Int']>;
  perfExpQtyPeriodSale?: InputMaybe<Scalars['Int']>;
  perfExpQtyPeriodSaleSign?: InputMaybe<ComparisonSign>;
  perfIdealStock?: InputMaybe<Scalars['Boolean']>;
  perfIdealStockSender?: InputMaybe<Scalars['Boolean']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  productCouv?: InputMaybe<WarehouseStock>;
  productCouvSign?: InputMaybe<ComparisonSign>;
  productCustomField1ValueCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCustomField2ValueCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCustomField3ValueCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCustomField4ValueCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCustomField5ValueCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productDepartmentIds?: InputMaybe<Array<Scalars['Int']>>;
  productExcludesIds?: InputMaybe<Array<Scalars['Int']>>;
  productFamilyIds?: InputMaybe<Array<Scalars['Int']>>;
  productFromPeriod?: InputMaybe<Scalars['DateTime']>;
  productInStoreNbWeeks?: InputMaybe<Scalars['Int']>;
  productInStoreSign?: InputMaybe<ComparisonSign>;
  productMarkDownPercent?: InputMaybe<Scalars['Int']>;
  productMarkDownPeriodSign?: InputMaybe<ComparisonSign>;
  productMinimumPrice?: InputMaybe<Scalars['Int']>;
  productNbItem?: InputMaybe<Scalars['Int']>;
  productNbWeek?: InputMaybe<Scalars['Int']>;
  productQtyPeriodNbItem?: InputMaybe<Scalars['Int']>;
  productQtyPeriodSign?: InputMaybe<ComparisonSign>;
  productRestockNbWeeks?: InputMaybe<Scalars['Int']>;
  productSalePeriod?: InputMaybe<SalePeriod>;
  productSeasonsIds?: InputMaybe<Array<Scalars['Int']>>;
  productSize?: InputMaybe<WarehouseStock>;
  productSizeSign?: InputMaybe<ComparisonSign>;
  productSubFamilyIds?: InputMaybe<Array<Scalars['Int']>>;
  referencyColor?: InputMaybe<ReferencyColor>;
  referencyTransfert?: InputMaybe<ReferencyTransfert>;
  saved?: InputMaybe<Scalars['Boolean']>;
  storeCountriesIds?: InputMaybe<Array<Scalars['Int']>>;
  storeCustomField1ValueCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  storeCustomField2ValueCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  storeCustomField3ValueCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  storeCustomField4ValueCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  storeCustomField5ValueCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  storeRecipientExcludesIds?: InputMaybe<Array<Scalars['Int']>>;
  storeRegionsIds?: InputMaybe<Array<Scalars['Int']>>;
  storeSenderExcludesIds?: InputMaybe<Array<Scalars['Int']>>;
  storeTypesIds?: InputMaybe<Array<Scalars['Int']>>;
  universeId: Scalars['Int'];
};

export type SwitchConfigIdInput = {
  id: Scalars['Int'];
};

export type SwitchResulPackageStats = {
  __typename?: 'SwitchResulPackageStats';
  avgRefsPerPackage: Scalars['Float'];
  carbonFootprint?: Maybe<Scalars['Decimal']>;
  globalEstimatedProfit: Scalars['Float'];
  globalEstimatedProfitBenef: Scalars['Float'];
  globalEstimatedRevenue: Scalars['Float'];
  globalEstimatedRevenueBenef: Scalars['Float'];
  id: Scalars['Int'];
  interRegionTransfers: Scalars['Int'];
  numberOfItemSentToWarehouse: Scalars['Int'];
  numberOfProduct: Scalars['Int'];
  storeTransport: Scalars['Float'];
  totalPackagesSent: Scalars['Int'];
  totalProductsSent: Scalars['Int'];
  totalTransport: Scalars['Float'];
  warehouseTransport: Scalars['Float'];
};

export type SwitchResult = {
  __typename?: 'SwitchResult';
  config?: Maybe<SwitchConfig>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  metadata?: Maybe<SwitchResultMetadata>;
  packages?: Maybe<Array<Maybe<SwitchResultPackage>>>;
  processed?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
  switchResultArticleStores?: Maybe<Array<Maybe<SwitchResultArticleStore>>>;
  switchResultProducts?: Maybe<Array<Maybe<SwitchResultProduct>>>;
  switchResultStoreReceivers?: Maybe<Array<Maybe<SwitchResultStoreReceiver>>>;
  switchResultStoreSenders?: Maybe<Array<Maybe<SwitchResultStoreSender>>>;
  user?: Maybe<User>;
  userGuid?: Maybe<Scalars['String']>;
  validated?: Maybe<Scalars['Boolean']>;
  validatedAt?: Maybe<Scalars['DateTime']>;
};

export type SwitchResultArticleStore = {
  __typename?: 'SwitchResultArticleStore';
  articleSKU?: Maybe<Scalars['String']>;
  flow: Scalars['Decimal'];
  gainInSales: Scalars['Decimal'];
  id: Scalars['Int'];
  labelColor?: Maybe<Scalars['String']>;
  price: Scalars['Decimal'];
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  receiverCode?: Maybe<Scalars['String']>;
  receiverName?: Maybe<Scalars['String']>;
  recipientNeeds: Scalars['Int'];
  recipientSales: Scalars['Int'];
  recipientStocks: Scalars['Int'];
  salesGain: Scalars['Decimal'];
  shipperCode?: Maybe<Scalars['String']>;
  shipperName?: Maybe<Scalars['String']>;
  shipperSales: Scalars['Int'];
  shipperStocks: Scalars['Int'];
  size?: Maybe<Scalars['String']>;
  switchResultId: Scalars['Int'];
  transferQuantity: Scalars['Int'];
};

export type SwitchResultMetadata = {
  __typename?: 'SwitchResultMetadata';
  id: Scalars['Int'];
  stats?: Maybe<SwitchResulPackageStats>;
};

export type SwitchResultPackage = {
  __typename?: 'SwitchResultPackage';
  id: Scalars['Int'];
  items?: Maybe<Array<Maybe<SwitchResultPackageItem>>>;
  receiver?: Maybe<Store>;
  sender?: Maybe<Store>;
};

export type SwitchResultPackageItem = {
  __typename?: 'SwitchResultPackageItem';
  centralSize: Scalars['Boolean'];
  codeCountry?: Maybe<Scalars['String']>;
  codeGeo?: Maybe<Scalars['String']>;
  codeZone?: Maybe<Scalars['String']>;
  colorCode?: Maybe<Scalars['String']>;
  costPrice: Scalars['Decimal'];
  genericId?: Maybe<Scalars['String']>;
  genericIdWithoutSize?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  initSellPrice: Scalars['Decimal'];
  quantity: Scalars['Decimal'];
  sKU?: Maybe<Scalars['String']>;
};

export type SwitchResultProduct = {
  __typename?: 'SwitchResultProduct';
  colorLabel?: Maybe<Scalars['String']>;
  disable: Scalars['Boolean'];
  gainInSales: Scalars['Decimal'];
  id: Scalars['Int'];
  periodSales: Scalars['Int'];
  price: Scalars['Decimal'];
  productCode?: Maybe<Scalars['String']>;
  productId: Scalars['Int'];
  productName?: Maybe<Scalars['String']>;
  recipientBreakageRate: Scalars['Decimal'];
  recipientFlowRate: Scalars['Decimal'];
  recipientStock: Scalars['Int'];
  salesGain: Scalars['Decimal'];
  salesRecipient: Scalars['Int'];
  shipperFlowRate: Scalars['Decimal'];
  shipperSales: Scalars['Int'];
  shipperStocks: Scalars['Int'];
  stockStore: Scalars['Int'];
  storeFlowRate: Scalars['Decimal'];
  switchResultId: Scalars['Int'];
  totalflowrate: Scalars['Decimal'];
  transferQuantity: Scalars['Int'];
  warehouseStock: Scalars['Int'];
  warehouseVsTotalStock: Scalars['Decimal'];
};

export type SwitchResultStoreReceiver = {
  __typename?: 'SwitchResultStoreReceiver';
  disable: Scalars['Boolean'];
  id: Scalars['Int'];
  nbTransfert: Scalars['Int'];
  salesStoreRecipient: Scalars['Int'];
  salesStoreShipper: Scalars['Int'];
  stockStoreRecipient: Scalars['Int'];
  stockStoreShipper: Scalars['Int'];
  store?: Maybe<Store>;
  storeFullName?: Maybe<Scalars['String']>;
  switchResultId: Scalars['Int'];
  transferQuantity: Scalars['Int'];
};

export type SwitchResultStoreSender = {
  __typename?: 'SwitchResultStoreSender';
  disable: Scalars['Boolean'];
  id: Scalars['Int'];
  nbTransfert: Scalars['Int'];
  salesStoreRecipient: Scalars['Int'];
  salesStoreShipper: Scalars['Int'];
  stockStoreRecipient: Scalars['Int'];
  stockStoreShipper: Scalars['Int'];
  store?: Maybe<Store>;
  storeFullName?: Maybe<Scalars['String']>;
  switchResultId: Scalars['Int'];
  transferQuantity: Scalars['Int'];
};

export type SwitchResultValidInput = {
  guid?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

export type SwitchSetting = {
  __typename?: 'SwitchSetting';
  activeProducts?: Maybe<Array<Maybe<Product>>>;
  activeStores?: Maybe<Array<Maybe<Store>>>;
  carbonFootPrintEnabled?: Maybe<Scalars['Boolean']>;
  centralSizeThreshold?: Maybe<Scalars['Int']>;
  co2PerKm?: Maybe<Scalars['Decimal']>;
  /** Product Custom fields (WIP) */
  productCustomFieldValues1Enabled?: Maybe<Scalars['Boolean']>;
  /** Product Custom fields (WIP) */
  productCustomFieldValues2Enabled?: Maybe<Scalars['Boolean']>;
  /** Product Custom fields (WIP) */
  productCustomFieldValues3Enabled?: Maybe<Scalars['Boolean']>;
  /** Product Custom fields (WIP) */
  productCustomFieldValues4Enabled?: Maybe<Scalars['Boolean']>;
  /** Product Custom fields (WIP) */
  productCustomFieldValues5Enabled?: Maybe<Scalars['Boolean']>;
  /** Departement */
  productDepartementEnabled?: Maybe<Scalars['Boolean']>;
  /** Famille */
  productFamilyEnabled?: Maybe<Scalars['Boolean']>;
  /** Sous famille */
  productSubFamilyEnabled?: Maybe<Scalars['Boolean']>;
  /** Store Custom fields (WIP) */
  storeCustomFieldValues1Enabled?: Maybe<Scalars['Boolean']>;
  /** Store Custom fields (WIP) */
  storeCustomFieldValues2Enabled?: Maybe<Scalars['Boolean']>;
  /** Store Custom fields (WIP) */
  storeCustomFieldValues3Enabled?: Maybe<Scalars['Boolean']>;
  /** Store Custom fields (WIP) */
  storeCustomFieldValues4Enabled?: Maybe<Scalars['Boolean']>;
  /** Store Custom fields (WIP) */
  storeCustomFieldValues5Enabled?: Maybe<Scalars['Boolean']>;
  storeRegionEnabled?: Maybe<Scalars['Boolean']>;
  storeTypeEnabled?: Maybe<Scalars['Boolean']>;
  transfertDefaultRC?: Maybe<ReferencyColor>;
  transfertDefaultRCT?: Maybe<ReferencyTransfert>;
  transportCostPerItem?: Maybe<Scalars['Decimal']>;
  transportRemovalCost?: Maybe<Scalars['Int']>;
};

export type SwitchSettingFormInput = {
  activeProductsIds?: InputMaybe<Array<Scalars['Int']>>;
  activeStoresIds?: InputMaybe<Array<Scalars['Int']>>;
  carbonFootPrintEnabled?: InputMaybe<Scalars['Boolean']>;
  centralSizeThreshold?: InputMaybe<Scalars['Int']>;
  co2PerKm?: InputMaybe<Scalars['Decimal']>;
  productCustomFieldValues1Enabled?: InputMaybe<Scalars['Boolean']>;
  productCustomFieldValues2Enabled?: InputMaybe<Scalars['Boolean']>;
  productCustomFieldValues3Enabled?: InputMaybe<Scalars['Boolean']>;
  productCustomFieldValues4Enabled?: InputMaybe<Scalars['Boolean']>;
  productCustomFieldValues5Enabled?: InputMaybe<Scalars['Boolean']>;
  productDepartementEnabled?: InputMaybe<Scalars['Boolean']>;
  productFamilyEnabled?: InputMaybe<Scalars['Boolean']>;
  productSubFamilyEnabled?: InputMaybe<Scalars['Boolean']>;
  storeCustomFieldValues1Enabled?: InputMaybe<Scalars['Boolean']>;
  storeCustomFieldValues2Enabled?: InputMaybe<Scalars['Boolean']>;
  storeCustomFieldValues3Enabled?: InputMaybe<Scalars['Boolean']>;
  storeCustomFieldValues4Enabled?: InputMaybe<Scalars['Boolean']>;
  storeCustomFieldValues5Enabled?: InputMaybe<Scalars['Boolean']>;
  storeRegionEnabled?: InputMaybe<Scalars['Boolean']>;
  storeTypeEnabled?: InputMaybe<Scalars['Boolean']>;
  transfertDefaultRC?: InputMaybe<ReferencyColor>;
  transfertDefaultRCT?: InputMaybe<ReferencyTransfert>;
  transportCostPerItem?: InputMaybe<Scalars['Decimal']>;
  transportRemovalCost?: InputMaybe<Scalars['Int']>;
};

export type TenantSettings = {
  __typename?: 'TenantSettings';
  id: Scalars['Int'];
  isErpMasterOfCreationAndModification: Scalars['Boolean'];
  productCoefficient: Scalars['Decimal'];
  productCoverage: Scalars['Int'];
  productCustomFieldName1?: Maybe<Scalars['String']>;
  productCustomFieldName2?: Maybe<Scalars['String']>;
  productCustomFieldName3?: Maybe<Scalars['String']>;
  productCustomFieldName4?: Maybe<Scalars['String']>;
  productCustomFieldName5?: Maybe<Scalars['String']>;
  productCustomFieldValues1?: Maybe<Scalars['String']>;
  productCustomFieldValues2?: Maybe<Scalars['String']>;
  productCustomFieldValues3?: Maybe<Scalars['String']>;
  productCustomFieldValues4?: Maybe<Scalars['String']>;
  productCustomFieldValues5?: Maybe<Scalars['String']>;
  productMaxStrength: Scalars['Int'];
  storeAverageStrength: Scalars['Int'];
  storeCapacityType: CapacityType;
  storeCoefficient: Scalars['Decimal'];
  storeCustomFieldName1?: Maybe<Scalars['String']>;
  storeCustomFieldName2?: Maybe<Scalars['String']>;
  storeCustomFieldName3?: Maybe<Scalars['String']>;
  storeCustomFieldName4?: Maybe<Scalars['String']>;
  storeCustomFieldName5?: Maybe<Scalars['String']>;
  storeCustomFieldValues1?: Maybe<Scalars['String']>;
  storeCustomFieldValues2?: Maybe<Scalars['String']>;
  storeCustomFieldValues3?: Maybe<Scalars['String']>;
  storeCustomFieldValues4?: Maybe<Scalars['String']>;
  storeCustomFieldValues5?: Maybe<Scalars['String']>;
  storeMaxStrength: Scalars['Int'];
  storeNumberOfWeeksStrength: Scalars['Int'];
  storePerformancePermutationField1?: Maybe<PermutationFieldType>;
  storePerformancePermutationField2?: Maybe<PermutationFieldType>;
};

export type TenantSettingsUpdateInput = {
  id: Scalars['Int'];
  productCoefficient?: InputMaybe<Scalars['Decimal']>;
  productCoverage?: InputMaybe<Scalars['Int']>;
  productMaxStrength?: InputMaybe<Scalars['Int']>;
  storeAverageStrength?: InputMaybe<Scalars['Int']>;
  storeCapacityType?: InputMaybe<CapacityType>;
  storeCoefficient?: InputMaybe<Scalars['Decimal']>;
  storeMaxStrength?: InputMaybe<Scalars['Int']>;
  storeNumberOfWeeksStrength?: InputMaybe<Scalars['Int']>;
  storePerformancePermutationField1?: InputMaybe<PermutationFieldType>;
  storePerformancePermutationField2?: InputMaybe<PermutationFieldType>;
};

export type Universe = {
  __typename?: 'Universe';
  code?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  email?: Maybe<Scalars['String']>;
  guid?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  jobDescription?: Maybe<Scalars['String']>;
  osrAccess: Scalars['Boolean'];
  switchAccess: Scalars['Boolean'];
  userRoleId: UserRoleType;
  userSettings?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type UserCreateInput = {
  email: Scalars['String'];
  jobDescription: Scalars['String'];
  osrAccess: Scalars['Boolean'];
  switchAccess: Scalars['Boolean'];
  userRoleType: UserRoleType;
  username: Scalars['String'];
};

export type UserInfoDto = {
  __typename?: 'UserInfoDto';
  osrAccess: Scalars['Boolean'];
  permissions?: Maybe<Array<PermissionsEnum>>;
  switchAccess: Scalars['Boolean'];
  userSettings?: Maybe<Scalars['String']>;
};

export type UserRole = {
  __typename?: 'UserRole';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export enum UserRoleType {
  Admin = 'ADMIN',
  Editor = 'EDITOR',
  Viewer = 'VIEWER'
}

export type UserUpdateInput = {
  id: Scalars['Int'];
  jobDescription?: InputMaybe<Scalars['String']>;
  osrAccess?: InputMaybe<Scalars['Boolean']>;
  switchAccess?: InputMaybe<Scalars['Boolean']>;
  userRoleType?: InputMaybe<UserRoleType>;
  userSettings?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type Warehouse = {
  __typename?: 'Warehouse';
  code?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isRetail: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  supplierId?: Maybe<Scalars['Int']>;
};

export enum WarehouseStock {
  All = 'ALL',
  Center = 'CENTER',
  None = 'NONE'
}

export type Mutations = {
  __typename?: 'mutations';
  bulkUpdateUser: Array<Maybe<User>>;
  /** Create a new switch */
  createSwitchConfig: SwitchConfig;
  createUser: User;
  /** Unsaved config */
  deleteSwitchConfig: SwitchConfig;
  deleteUser: Scalars['Boolean'];
  /** Delete a switch result */
  discardSwitchResult: Scalars['String'];
  generateExport: Scalars['Boolean'];
  /** Get senders receiver couple lists */
  sendersReceiverStores: StoreSenderReceiverListDto;
  /** Toggle pinned */
  togglePinSwitchConfig: SwitchConfig;
  /** Toggle saved */
  toggleSaveSwitchConfig: SwitchConfig;
  /** Global switch settings */
  updateSettings: SwitchSetting;
  /** Enable or disable store universe */
  updateStoreUniverseActive: Scalars['Boolean'];
  updateTenantSettings: Scalars['Boolean'];
  updateUser: User;
  updateUserSettings?: Maybe<Scalars['String']>;
  /** Save switch result */
  validateSwitchResult: SwitchResult;
};


export type MutationsBulkUpdateUserArgs = {
  usersInput?: InputMaybe<Array<InputMaybe<UserUpdateInput>>>;
};


export type MutationsCreateSwitchConfigArgs = {
  switchConfigInput?: InputMaybe<SwitchConfigFormInput>;
};


export type MutationsCreateUserArgs = {
  userInput?: InputMaybe<UserCreateInput>;
};


export type MutationsDeleteSwitchConfigArgs = {
  switchConfigIdInput?: InputMaybe<SwitchConfigIdInput>;
};


export type MutationsDeleteUserArgs = {
  userId: Scalars['Int'];
};


export type MutationsDiscardSwitchResultArgs = {
  switchResultValidInput?: InputMaybe<SwitchResultValidInput>;
};


export type MutationsSendersReceiverStoresArgs = {
  switchConfigInput?: InputMaybe<SwitchConfigFormInput>;
};


export type MutationsTogglePinSwitchConfigArgs = {
  switchConfigIdInput?: InputMaybe<SwitchConfigIdInput>;
};


export type MutationsToggleSaveSwitchConfigArgs = {
  switchConfigIdInput?: InputMaybe<SwitchConfigIdInput>;
};


export type MutationsUpdateSettingsArgs = {
  switchSettingInput?: InputMaybe<SwitchSettingFormInput>;
};


export type MutationsUpdateStoreUniverseActiveArgs = {
  storeActiveStateInput?: InputMaybe<StoreActiveStateInput>;
};


export type MutationsUpdateTenantSettingsArgs = {
  tenantSettings?: InputMaybe<TenantSettingsUpdateInput>;
};


export type MutationsUpdateUserArgs = {
  userInput?: InputMaybe<UserUpdateInput>;
};


export type MutationsUpdateUserSettingsArgs = {
  userSettings?: InputMaybe<Scalars['String']>;
};


export type MutationsValidateSwitchResultArgs = {
  switchResultValidInput?: InputMaybe<SwitchResultValidInput>;
};

export type Queries = {
  __typename?: 'queries';
  /** Get all valid switch results */
  allValidSwitchResults: Array<Maybe<SwitchResult>>;
  auditableInfos?: Maybe<AuditableInfoDtoCollectionSegment>;
  collection?: Maybe<Collection>;
  collections?: Maybe<Array<Collection>>;
  /** Return a list of possible values for comparison operations */
  comparisonSigns?: Maybe<Array<Maybe<ComparisonSign>>>;
  countries?: Maybe<Array<Country>>;
  /** Possibles names of custom fields */
  customFieldsNames?: Maybe<Scalars['Any']>;
  dashboard: DashboardDto;
  /** Return a list of departments */
  departments?: Maybe<Array<Department>>;
  exceptionOptimalStockTable: ExceptionOptimalStockTableDto;
  /** Return a list of products families */
  families?: Maybe<Array<Family>>;
  familyToSizeSystem?: Maybe<Array<Family>>;
  fileImportLog: FileImportLog;
  fileImportLogs?: Maybe<Array<FileImportLog>>;
  /** Return a list of possible values maximization criterion */
  maximizationCriteria?: Maybe<Array<Maybe<MaximizationCriterion>>>;
  optimalStockOverride?: Maybe<Array<ArticleOptimalStockOverride>>;
  optimalStockSimulation?: Maybe<PaginationInfoOfOptimalStockSimulationDto>;
  possiblePermutations?: Maybe<Array<Scalars['String']>>;
  productCustomFields: ProductCustomFieldsDto;
  productDetails: ProductDetailsDto;
  productOptimalStockProductSummary?: Maybe<ProductOptimalStockSummaryDto>;
  productPerformance?: Maybe<Array<ProductFleetPerformanceDto>>;
  products?: Maybe<Array<MvProduct>>;
  /** Return a list of products by season and universes */
  productsList?: Maybe<Array<ProductSettingsDto>>;
  /** Return a list of possible values for color referency option */
  referencyColors?: Maybe<Array<Maybe<ReferencyColor>>>;
  /** Return a list of possible values for transfert referency option */
  referencyTransferts?: Maybe<Array<Maybe<ReferencyTransfert>>>;
  regions?: Maybe<Array<AddressRegion>>;
  /** Return initial config used to create the result */
  resultOriginConfig: SwitchConfig;
  retailWarehouseStock?: Maybe<Array<ExceptionOptimalStockRetailStockDto>>;
  /** Return a list of possible values for period of sales */
  salePeriods?: Maybe<Array<Maybe<SalePeriod>>>;
  /** Return a list of products seasons */
  seasons?: Maybe<Array<Season>>;
  /** Simulate a switch, return the processId to track progression */
  simulateSwitch: SimulationDto;
  /** Track the progression of a simulation using processId. Error if the given processId is not running */
  simulationProgress: SimulationDto;
  sizeSystemRowHeaders?: Maybe<Array<SizeSystemRowHeader>>;
  sizeSystemRows?: Maybe<Array<SizeSystemRow>>;
  sizeSystems?: Maybe<Array<SizeSystem>>;
  stocksSalesTable: ProductOptimalSalesTableDto;
  /** Stop a running simulation */
  stopSimulation: SimulationDto;
  storeCustomFields: StoreCustomFieldsDto;
  storeDetails?: Maybe<StoreDetailsDto>;
  storeFleet?: Maybe<Array<StoreFleetDto>>;
  storeFleetSummary: StoreFleetSummaryTableDto;
  storeGroups?: Maybe<Array<StoreGroup>>;
  storeOptimalStockExceptions?: Maybe<Array<StoreOptimalStockExceptionDto>>;
  storePerformance?: Maybe<Array<StorePerformanceDto>>;
  storePerformancePermutationSummary?: Maybe<Array<StorePerformancePermutationSummaryDto>>;
  storePerformanceStoreSummary?: Maybe<Array<StorePerformanceStoreSummaryDto>>;
  storeStrengthTable: ProductOptimalStockTableWrapperDto;
  storeTypes?: Maybe<Array<StoreType>>;
  /** Return stores for ids countries and regions (optional) given */
  stores?: Maybe<Array<Store>>;
  /** Return stores list for settings */
  storesSetting?: Maybe<Array<StoreSettingDto>>;
  /** Return a list of products sub families */
  subFamilies?: Maybe<Array<SubFamily>>;
  /** Return a full switch configuration */
  switchConfig: SwitchConfig;
  /** Return a full switch configuration as a form input */
  switchConfigForm: SwitchConfigFormDto;
  /** Get switch last result */
  switchLastResult: SwitchResult;
  /** Get switch result by process guid */
  switchResultByGuid: SwitchResult;
  /** Get switch results lists */
  switchResults: Array<Maybe<SwitchResult>>;
  /** Return global switch settings */
  switchSetting: SwitchSetting;
  /** Return a list of every switch configurations accessible for the user */
  switchesConfigs?: Maybe<Array<SwitchConfig>>;
  tenantSettings: TenantSettings;
  /** Return a list of universes (brand) */
  universes?: Maybe<Array<Universe>>;
  user?: Maybe<Array<User>>;
  userRoles?: Maybe<Array<UserRole>>;
  userSettings: UserInfoDto;
  users?: Maybe<Array<User>>;
  /** Get Refreshing Views Status */
  viewsStatus: RefreshViewsStatus;
  /** Return a list of possible values for warehouse stock option */
  warehouseStocks?: Maybe<Array<Maybe<WarehouseStock>>>;
  warehouses?: Maybe<Array<Warehouse>>;
};


export type QueriesAuditableInfosArgs = {
  dateRangeEnd?: InputMaybe<Scalars['DateTime']>;
  dateRangeStart?: InputMaybe<Scalars['DateTime']>;
  objectType?: InputMaybe<AuditableObjectType>;
  seasonCode?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userGuid?: InputMaybe<Scalars['String']>;
};


export type QueriesCollectionArgs = {
  id: Scalars['Int'];
  isActive?: InputMaybe<Scalars['Boolean']>;
};


export type QueriesCollectionsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  universeId: Scalars['Int'];
};


export type QueriesExceptionOptimalStockTableArgs = {
  hasException: Scalars['Boolean'];
  productId: Scalars['Int'];
  salesEnum: ExceptionOptimalStockSalesEnum;
  stockEnum: ExceptionOptimalStockStockEnum;
};


export type QueriesFamilyToSizeSystemArgs = {
  sizeSystemId: Scalars['Int'];
};


export type QueriesFileImportLogArgs = {
  fileImportLogId: Scalars['Int'];
};


export type QueriesOptimalStockOverrideArgs = {
  articleId: Scalars['Int'];
};


export type QueriesOptimalStockSimulationArgs = {
  customField1?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customField2?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customField3?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customField4?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  customField5?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filters?: InputMaybe<Array<OptimalStockSimulationFilterDtoInput>>;
  isAsc?: InputMaybe<Scalars['Boolean']>;
  permutations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  seasonId?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  sortType?: InputMaybe<OptimalStockSimulationField>;
  take?: InputMaybe<Scalars['Int']>;
  universeId: Scalars['Int'];
};


export type QueriesProductDetailsArgs = {
  id: Scalars['Int'];
};


export type QueriesProductOptimalStockProductSummaryArgs = {
  productId: Scalars['Int'];
};


export type QueriesProductPerformanceArgs = {
  seasonId: Scalars['Int'];
  universeId: Scalars['Int'];
};


export type QueriesProductsArgs = {
  couvNbWeeks?: InputMaybe<Scalars['Int']>;
  couvSize?: InputMaybe<WarehouseStock>;
  couvSizeComparisionSign?: InputMaybe<ComparisonSign>;
  departmentIds?: InputMaybe<Array<Scalars['Int']>>;
  familyIds?: InputMaybe<Array<Scalars['Int']>>;
  fromPeriod?: InputMaybe<Scalars['DateTime']>;
  inStoreNbWeeks?: InputMaybe<Scalars['Int']>;
  inStoreSign?: InputMaybe<ComparisonSign>;
  markDownPercent?: InputMaybe<Scalars['Int']>;
  markDownPeriodSign?: InputMaybe<ComparisonSign>;
  minPrice?: InputMaybe<Scalars['Decimal']>;
  nbPieces?: InputMaybe<Scalars['Int']>;
  period?: InputMaybe<SalePeriod>;
  productCustomField1Codes?: InputMaybe<Array<Scalars['String']>>;
  productCustomField2Codes?: InputMaybe<Array<Scalars['String']>>;
  productCustomField3Codes?: InputMaybe<Array<Scalars['String']>>;
  productCustomField4Codes?: InputMaybe<Array<Scalars['String']>>;
  productCustomField5Codes?: InputMaybe<Array<Scalars['String']>>;
  qtyPeriodNbPiece?: InputMaybe<Scalars['Int']>;
  qtyPeriodSign?: InputMaybe<ComparisonSign>;
  restockNbWeeks?: InputMaybe<Scalars['Int']>;
  seasonsIds: Array<Scalars['Int']>;
  size?: InputMaybe<WarehouseStock>;
  sizeComparisionSign?: InputMaybe<ComparisonSign>;
  storeIds?: InputMaybe<Array<Scalars['Int']>>;
  storeTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  storesDestExcludesIds?: InputMaybe<Array<Scalars['Int']>>;
  storesExpExcludesIds?: InputMaybe<Array<Scalars['Int']>>;
  subFamilyIds?: InputMaybe<Array<Scalars['Int']>>;
  universeId: Scalars['Int'];
};


export type QueriesProductsListArgs = {
  familyCodes?: InputMaybe<Array<Scalars['String']>>;
  seasonCodes?: InputMaybe<Array<Scalars['String']>>;
  universeCodes?: InputMaybe<Array<Scalars['String']>>;
};


export type QueriesRegionsArgs = {
  countries?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueriesResultOriginConfigArgs = {
  id: Scalars['Int'];
};


export type QueriesRetailWarehouseStockArgs = {
  productId: Scalars['Int'];
};


export type QueriesSimulateSwitchArgs = {
  switchConfigId: Scalars['Int'];
};


export type QueriesSimulationProgressArgs = {
  processId?: InputMaybe<Scalars['String']>;
};


export type QueriesSizeSystemRowHeadersArgs = {
  sizeSystemId: Scalars['Int'];
};


export type QueriesSizeSystemRowsArgs = {
  sizeSystemId: Scalars['Int'];
};


export type QueriesStocksSalesTableArgs = {
  productId: Scalars['Int'];
};


export type QueriesStopSimulationArgs = {
  processId?: InputMaybe<Scalars['String']>;
  switchConfigId: Scalars['Int'];
};


export type QueriesStoreDetailsArgs = {
  id?: InputMaybe<Scalars['Int']>;
  seasonId: Scalars['Int'];
  universeId: Scalars['Int'];
};


export type QueriesStoreFleetArgs = {
  seasonId: Scalars['Int'];
  universeId: Scalars['Int'];
};


export type QueriesStoreFleetSummaryArgs = {
  seasonId: Scalars['Int'];
  universeId: Scalars['Int'];
};


export type QueriesStoreGroupsArgs = {
  collectionId: Scalars['Int'];
};


export type QueriesStoreOptimalStockExceptionsArgs = {
  isIncluded?: InputMaybe<Scalars['Boolean']>;
  productId: Scalars['Int'];
};


export type QueriesStorePerformanceArgs = {
  seasonId: Scalars['Int'];
  universeId: Scalars['Int'];
};


export type QueriesStorePerformancePermutationSummaryArgs = {
  seasonId: Scalars['Int'];
  universeId: Scalars['Int'];
};


export type QueriesStorePerformanceStoreSummaryArgs = {
  seasonId: Scalars['Int'];
  universeId: Scalars['Int'];
};


export type QueriesStoreStrengthTableArgs = {
  productId: Scalars['Int'];
};


export type QueriesStoreTypesArgs = {
  countries?: InputMaybe<Array<Scalars['Int']>>;
  regions?: InputMaybe<Array<Scalars['Int']>>;
  universeId: Scalars['Int'];
};


export type QueriesStoresArgs = {
  countries?: InputMaybe<Array<Scalars['Int']>>;
  regions?: InputMaybe<Array<Scalars['Int']>>;
  storeCustomField1Codes?: InputMaybe<Array<Scalars['String']>>;
  storeCustomField2Codes?: InputMaybe<Array<Scalars['String']>>;
  storeCustomField3Codes?: InputMaybe<Array<Scalars['String']>>;
  storeCustomField4Codes?: InputMaybe<Array<Scalars['String']>>;
  storeCustomField5Codes?: InputMaybe<Array<Scalars['String']>>;
  types?: InputMaybe<Array<Scalars['Int']>>;
  universeId: Scalars['Int'];
};


export type QueriesStoresSettingArgs = {
  seasonId?: InputMaybe<Scalars['Int']>;
  universeId: Scalars['Int'];
};


export type QueriesSwitchConfigArgs = {
  id: Scalars['Int'];
};


export type QueriesSwitchConfigFormArgs = {
  id: Scalars['Int'];
};


export type QueriesSwitchLastResultArgs = {
  isProcessed?: InputMaybe<Scalars['Boolean']>;
  isSuccess?: InputMaybe<Scalars['Boolean']>;
  switchConfigId: Scalars['Int'];
};


export type QueriesSwitchResultByGuidArgs = {
  guid?: InputMaybe<Scalars['String']>;
};


export type QueriesSwitchResultsArgs = {
  isProcessed?: InputMaybe<Scalars['Boolean']>;
  isSuccess?: InputMaybe<Scalars['Boolean']>;
  isValidated?: InputMaybe<Scalars['Boolean']>;
  switchConfigId?: InputMaybe<Scalars['Int']>;
};


export type QueriesSwitchesConfigsArgs = {
  isPinned?: InputMaybe<Scalars['Boolean']>;
  isSaved?: InputMaybe<Scalars['Boolean']>;
};


export type QueriesUserArgs = {
  userGuid: Scalars['String'];
};

export type CreateSwitchConfigMutationVariables = Exact<{
  switchConfigInput?: InputMaybe<SwitchConfigFormInput>;
}>;


export type CreateSwitchConfigMutation = { __typename?: 'mutations', createSwitchConfig: { __typename?: 'SwitchConfig', createAt: any, editedAt?: any | null, id: number, name?: string | null } };

export type DeleteSwitchConfigMutationVariables = Exact<{
  switchConfigIdInput?: InputMaybe<SwitchConfigIdInput>;
}>;


export type DeleteSwitchConfigMutation = { __typename?: 'mutations', deleteSwitchConfig: { __typename?: 'SwitchConfig', id: number } };

export type UpdateSettingsMutationVariables = Exact<{
  switchSettingInput?: InputMaybe<SwitchSettingFormInput>;
}>;


export type UpdateSettingsMutation = { __typename?: 'mutations', updateSettings: { __typename?: 'SwitchSetting', productFamilyEnabled?: boolean | null } };

export type ValidateSwitchResultMutationVariables = Exact<{
  switchResultValidInput?: InputMaybe<SwitchResultValidInput>;
}>;


export type ValidateSwitchResultMutation = { __typename?: 'mutations', validateSwitchResult: { __typename?: 'SwitchResult', id: number } };

export type UpdateStoreUniverseActiveMutationVariables = Exact<{
  storeActiveState?: InputMaybe<StoreActiveStateInput>;
}>;


export type UpdateStoreUniverseActiveMutation = { __typename?: 'mutations', updateStoreUniverseActive: boolean };

export type GetRegionsQueryVariables = Exact<{
  countries?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GetRegionsQuery = { __typename?: 'queries', regions?: Array<{ __typename?: 'AddressRegion', id: number, name?: string | null, depName?: string | null, depNum?: string | null, country?: { __typename?: 'Country', id: number, name?: string | null, alpha3?: string | null } | null }> | null };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename?: 'queries', countries?: Array<{ __typename?: 'Country', id: number, name?: string | null, alpha3?: string | null }> | null };

export type GetStoreTypesQueryVariables = Exact<{
  universeId: Scalars['Int'];
  countries?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  regions?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GetStoreTypesQuery = { __typename?: 'queries', storeTypes?: Array<{ __typename?: 'StoreType', id: number, code?: string | null, name?: string | null, isMain: boolean, isWeb: boolean }> | null };

export type GetStoresQueryVariables = Exact<{
  universeId: Scalars['Int'];
  countries?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  regions?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  types?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  storeCustomField1Codes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  storeCustomField2Codes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  storeCustomField3Codes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  storeCustomField4Codes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  storeCustomField5Codes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetStoresQuery = { __typename?: 'queries', stores?: Array<{ __typename?: 'Store', id: number, code?: string | null, name?: string | null, storeType?: { __typename?: 'StoreType', id: number, code?: string | null, name?: string | null, isMain: boolean, isWeb: boolean } | null, address?: { __typename?: 'Address', id: number, address1?: string | null, address2?: string | null, zipCode?: string | null, addressRegion?: { __typename?: 'AddressRegion', id: number, name?: string | null, depName?: string | null, depNum?: string | null } | null, country?: { __typename?: 'Country', id: number, name?: string | null, alpha3?: string | null } | null } | null }> | null };

export type GetSeasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSeasonsQuery = { __typename?: 'queries', seasons?: Array<{ __typename?: 'Season', id: number, code?: string | null, name?: string | null, isActive: boolean }> | null };

export type GetUniversesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUniversesQuery = { __typename?: 'queries', universes?: Array<{ __typename?: 'Universe', id: number, code?: string | null, name?: string | null }> | null };

export type GetDepartmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDepartmentsQuery = { __typename?: 'queries', departments?: Array<{ __typename?: 'Department', id: number, code?: string | null, name?: string | null }> | null };

export type GetFamiliesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFamiliesQuery = { __typename?: 'queries', families?: Array<{ __typename?: 'Family', id: number, code?: string | null, name?: string | null }> | null };

export type GetSubFamiliesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubFamiliesQuery = { __typename?: 'queries', subFamilies?: Array<{ __typename?: 'SubFamily', id: number, code?: string | null, name?: string | null }> | null };

export type GetProductsQueryVariables = Exact<{
  seasonsIds: Array<Scalars['Int']> | Scalars['Int'];
  storeIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  storeTypeIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  storesExpExcludesIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  storesDestExcludesIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  universeId: Scalars['Int'];
  familyIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  subFamilyIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  departmentIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  productCustomField1Codes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  productCustomField2Codes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  productCustomField3Codes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  productCustomField4Codes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  productCustomField5Codes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  minPrice?: InputMaybe<Scalars['Decimal']>;
  size?: InputMaybe<WarehouseStock>;
  sizeComparisionSign?: InputMaybe<ComparisonSign>;
  nbPieces?: InputMaybe<Scalars['Int']>;
  couvSize?: InputMaybe<WarehouseStock>;
  couvSizeComparisionSign?: InputMaybe<ComparisonSign>;
  couvNbWeeks?: InputMaybe<Scalars['Int']>;
  period?: InputMaybe<SalePeriod>;
  fromPeriod?: InputMaybe<Scalars['DateTime']>;
  qtyPeriodSign?: InputMaybe<ComparisonSign>;
  qtyPeriodNbPiece?: InputMaybe<Scalars['Int']>;
  inStoreSign?: InputMaybe<ComparisonSign>;
  inStoreNbWeeks?: InputMaybe<Scalars['Int']>;
  restockNbWeeks?: InputMaybe<Scalars['Int']>;
  markDownPeriodSign?: InputMaybe<ComparisonSign>;
  markDownPercent?: InputMaybe<Scalars['Int']>;
}>;


export type GetProductsQuery = { __typename?: 'queries', products?: Array<{ __typename?: 'MVProduct', productId: number, colorName?: string | null, familyName?: string | null, productName?: string | null, productPrice: any, salesPeriod?: number | null, stkStoreVsStkTotal?: any | null, stockStore?: number | null, storeFlowRate?: any | null, theme?: string | null, totalFlowRate?: any | null, warehouseStock?: number | null, productCode?: string | null }> | null };

export type GetSimpleSwitchesConfigsQueryVariables = Exact<{
  isSaved?: InputMaybe<Scalars['Boolean']>;
  isPinned?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetSimpleSwitchesConfigsQuery = { __typename?: 'queries', switchesConfigs?: Array<{ __typename?: 'SwitchConfig', id: number, name?: string | null }> | null };

export type GetSwitchesConfigsQueryVariables = Exact<{
  isSaved?: InputMaybe<Scalars['Boolean']>;
  isPinned?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetSwitchesConfigsQuery = { __typename?: 'queries', switchesConfigs?: Array<{ __typename?: 'SwitchConfig', id: number, name?: string | null, createAt: any }> | null };

export type GetSwitchConfigByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetSwitchConfigByIdQuery = { __typename?: 'queries', switchConfig: { __typename?: 'SwitchConfig', carbonFootprintBonus?: boolean | null, createAt: any, editedAt?: any | null, id: number, interCountry?: boolean | null, interRegion?: boolean | null, maximizationCriterion?: MaximizationCriterion | null, name?: string | null, nbDestMax?: number | null, nbItemMaxTransfer?: number | null, nbItemMaxReceiver?: number | null, nbItemMin?: number | null, perfDestQtyPeriodSale?: number | null, perfDestQtyPeriodSaleSign?: ComparisonSign | null, perfExpFlowRatePercent?: number | null, perfExpFlowRateSign?: ComparisonSign | null, perfExpPresenceMin?: number | null, perfExpQtyPeriodSale?: number | null, perfExpQtyPeriodSaleSign?: ComparisonSign | null, perfIdealStock?: boolean | null, perfIdealStockSender?: boolean | null, pinned?: boolean | null, productCouv?: WarehouseStock | null, productCouvSign?: ComparisonSign | null, productFromPeriod?: any | null, productInStoreNbWeeks?: number | null, productInStoreSign?: ComparisonSign | null, productMarkDownPercent?: number | null, productMarkDownPeriodSign?: ComparisonSign | null, productMinimumPrice?: number | null, productNbItem?: number | null, productNbWeek?: number | null, productQtyPeriodSign?: ComparisonSign | null, productQtyPeriodNbItem?: number | null, productRestockNbWeeks?: number | null, productSalePeriod?: SalePeriod | null, productSize?: WarehouseStock | null, productSizeSign?: ComparisonSign | null, productCustomField1Values?: Array<string | null> | null, productCustomField2Values?: Array<string | null> | null, productCustomField3Values?: Array<string | null> | null, productCustomField4Values?: Array<string | null> | null, productCustomField5Values?: Array<string | null> | null, referencyColor?: ReferencyColor | null, referencyTransfert?: ReferencyTransfert | null, saved?: boolean | null, storeCustomField1Values?: Array<string | null> | null, storeCustomField2Values?: Array<string | null> | null, storeCustomField3Values?: Array<string | null> | null, storeCustomField4Values?: Array<string | null> | null, storeCustomField5Values?: Array<string | null> | null, productExcludes?: Array<{ __typename?: 'Product', id: number, familyId: number, isOnShowcase: boolean, isSynced: boolean, price: any, seasonId: number, sizeSystemId: number } | null> | null, productDepartments?: Array<{ __typename?: 'Department', id: number } | null> | null, productFamilies?: Array<{ __typename?: 'Family', id: number } | null> | null, productSeasons?: Array<{ __typename?: 'Season', id: number, isActive: boolean } | null> | null, productSubFamilies?: Array<{ __typename?: 'SubFamily', id: number } | null> | null, universe?: { __typename?: 'Universe', id: number } | null, storeCountries?: Array<{ __typename?: 'Country', id: number } | null> | null, storeRecipientExcludes?: Array<{ __typename?: 'Store', id: number } | null> | null, storeRegions?: Array<{ __typename?: 'AddressRegion', id: number } | null> | null, storeSenderExcludes?: Array<{ __typename?: 'Store', id: number } | null> | null, storeTypes?: Array<{ __typename?: 'StoreType', id: number, isMain: boolean, isWeb: boolean } | null> | null } };

export type GetSwitchConfigFormByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetSwitchConfigFormByIdQuery = { __typename?: 'queries', switchConfigForm: { __typename?: 'SwitchConfigFormDto', productExcludesIds?: Array<number> | null, carbonFootprintBonus?: boolean | null, id: number, interCountry?: boolean | null, interRegion?: boolean | null, maximizationCriterion?: MaximizationCriterion | null, name?: string | null, nbDestMax?: number | null, nbItemMaxTransfer?: number | null, nbItemMaxReceiver?: number | null, nbItemMin?: number | null, perfDestFlowRatePercent?: number | null, perfDestFlowRateSign?: ComparisonSign | null, perfDestQtyPeriodSale?: number | null, perfDestQtyPeriodSaleSign?: ComparisonSign | null, perfExpFlowRatePercent?: number | null, perfExpFlowRateSign?: ComparisonSign | null, perfExpPresenceMin?: number | null, perfExpQtyPeriodSale?: number | null, perfExpQtyPeriodSaleSign?: ComparisonSign | null, perfIdealStock?: boolean | null, perfIdealStockSender?: boolean | null, productCouv?: WarehouseStock | null, productCouvSign?: ComparisonSign | null, productDepartmentIds?: Array<number> | null, productFamilyIds?: Array<number> | null, productFromPeriod?: any | null, productInStoreNbWeeks?: number | null, productInStoreSign?: ComparisonSign | null, productMarkDownPercent?: number | null, productMarkDownPeriodSign?: ComparisonSign | null, productMinimumPrice?: number | null, productNbItem?: number | null, productNbWeek?: number | null, productQtyPeriodSign?: ComparisonSign | null, productQtyPeriodNbItem?: number | null, productRestockNbWeeks?: number | null, productSalePeriod?: SalePeriod | null, productSeasonsIds?: Array<number> | null, productSize?: WarehouseStock | null, productSizeSign?: ComparisonSign | null, productSubFamilyIds?: Array<number> | null, productCustomField1Values?: Array<string | null> | null, productCustomField2Values?: Array<string | null> | null, productCustomField3Values?: Array<string | null> | null, productCustomField4Values?: Array<string | null> | null, productCustomField5Values?: Array<string | null> | null, universeId: number, referencyColor?: ReferencyColor | null, referencyTransfert?: ReferencyTransfert | null, storeCountriesIds?: Array<number> | null, storeRecipientExcludesIds?: Array<number> | null, storeRegionsIds?: Array<number> | null, storeCustomField1Values?: Array<string | null> | null, storeCustomField2Values?: Array<string | null> | null, storeCustomField3Values?: Array<string | null> | null, storeCustomField4Values?: Array<string | null> | null, storeCustomField5Values?: Array<string | null> | null, storeSenderExcludesIds?: Array<number> | null, storeTypesIds?: Array<number> | null, saved?: boolean | null, pinned?: boolean | null } };

export type GetSimulateSwitchQueryVariables = Exact<{
  switchConfigId: Scalars['Int'];
}>;


export type GetSimulateSwitchQuery = { __typename?: 'queries', simulateSwitch: { __typename?: 'SimulationDto', processId?: string | null, processProgress: number, processStatus?: ProcessStatus | null } };

export type GetSimulationProgressQueryVariables = Exact<{
  processId?: InputMaybe<Scalars['String']>;
}>;


export type GetSimulationProgressQuery = { __typename?: 'queries', simulationProgress: { __typename?: 'SimulationDto', processId?: string | null, processProgress: number, processStatus?: ProcessStatus | null } };

export type StopSimulationQueryVariables = Exact<{
  switchConfigId: Scalars['Int'];
  processId?: InputMaybe<Scalars['String']>;
}>;


export type StopSimulationQuery = { __typename?: 'queries', stopSimulation: { __typename?: 'SimulationDto', processId?: string | null } };

export type GetSwitchResultsQueryVariables = Exact<{
  switchConfigId: Scalars['Int'];
  isSuccess?: InputMaybe<Scalars['Boolean']>;
  isProcessed?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetSwitchResultsQuery = { __typename?: 'queries', switchResults: Array<{ __typename?: 'SwitchResult', id: number, processed?: boolean | null, success?: boolean | null, config?: { __typename?: 'SwitchConfig', id: number } | null, metadata?: { __typename?: 'SwitchResultMetadata', id: number, stats?: { __typename?: 'SwitchResulPackageStats', avgRefsPerPackage: number, carbonFootprint?: any | null, globalEstimatedProfit: number, globalEstimatedRevenue: number, id: number, interRegionTransfers: number, numberOfItemSentToWarehouse: number, totalPackagesSent: number, totalProductsSent: number, numberOfProduct: number, globalEstimatedRevenueBenef: number, globalEstimatedProfitBenef: number, storeTransport: number, warehouseTransport: number, totalTransport: number } | null } | null, packages?: Array<{ __typename?: 'SwitchResultPackage', id: number, items?: Array<{ __typename?: 'SwitchResultPackageItem', centralSize: boolean, codeCountry?: string | null, codeGeo?: string | null, codeZone?: string | null, colorCode?: string | null, costPrice: any, genericId?: string | null, genericIdWithoutSize?: string | null, id: number, initSellPrice: any, quantity: any, sKU?: string | null } | null> | null, sender?: { __typename?: 'Store', id: number, code?: string | null, name?: string | null } | null, receiver?: { __typename?: 'Store', id: number, code?: string | null, name?: string | null } | null } | null> | null } | null> };

export type GetSwitchResultByGuidQueryVariables = Exact<{
  guid?: InputMaybe<Scalars['String']>;
}>;


export type GetSwitchResultByGuidQuery = { __typename?: 'queries', switchResultByGuid: { __typename?: 'SwitchResult', createdAt?: any | null, id: number, processed?: boolean | null, success?: boolean | null, config?: { __typename?: 'SwitchConfig', id: number, createAt: any } | null, metadata?: { __typename?: 'SwitchResultMetadata', id: number, stats?: { __typename?: 'SwitchResulPackageStats', avgRefsPerPackage: number, carbonFootprint?: any | null, globalEstimatedProfit: number, globalEstimatedRevenue: number, id: number, interRegionTransfers: number, numberOfItemSentToWarehouse: number, totalPackagesSent: number, totalProductsSent: number, numberOfProduct: number, globalEstimatedRevenueBenef: number, globalEstimatedProfitBenef: number, storeTransport: number, warehouseTransport: number, totalTransport: number } | null } | null, packages?: Array<{ __typename?: 'SwitchResultPackage', id: number, items?: Array<{ __typename?: 'SwitchResultPackageItem', centralSize: boolean, codeCountry?: string | null, codeGeo?: string | null, codeZone?: string | null, colorCode?: string | null, costPrice: any, genericId?: string | null, genericIdWithoutSize?: string | null, id: number, initSellPrice: any, quantity: any, sKU?: string | null } | null> | null, sender?: { __typename?: 'Store', id: number, code?: string | null, name?: string | null } | null, receiver?: { __typename?: 'Store', id: number, code?: string | null, name?: string | null } | null } | null> | null, switchResultArticleStores?: Array<{ __typename?: 'SwitchResultArticleStore', articleSKU?: string | null, flow: any, gainInSales: any, id: number, labelColor?: string | null, price: any, productCode?: string | null, productName?: string | null, receiverCode?: string | null, receiverName?: string | null, recipientNeeds: number, recipientSales: number, recipientStocks: number, salesGain: any, shipperCode?: string | null, shipperName?: string | null, shipperSales: number, shipperStocks: number, size?: string | null, switchResultId: number, transferQuantity: number } | null> | null, switchResultProducts?: Array<{ __typename?: 'SwitchResultProduct', colorLabel?: string | null, disable: boolean, gainInSales: any, id: number, periodSales: number, price: any, productId: number, productCode?: string | null, productName?: string | null, recipientBreakageRate: any, recipientFlowRate: any, recipientStock: number, salesGain: any, salesRecipient: number, shipperFlowRate: any, shipperSales: number, shipperStocks: number, stockStore: number, storeFlowRate: any, switchResultId: number, totalflowrate: any, transferQuantity: number, warehouseStock: number, warehouseVsTotalStock: any } | null> | null, switchResultStoreSenders?: Array<{ __typename?: 'SwitchResultStoreSender', disable: boolean, id: number, nbTransfert: number, salesStoreRecipient: number, salesStoreShipper: number, stockStoreRecipient: number, stockStoreShipper: number, storeFullName?: string | null, switchResultId: number, transferQuantity: number, store?: { __typename?: 'Store', id: number } | null } | null> | null, switchResultStoreReceivers?: Array<{ __typename?: 'SwitchResultStoreReceiver', disable: boolean, id: number, nbTransfert: number, salesStoreRecipient: number, salesStoreShipper: number, stockStoreRecipient: number, stockStoreShipper: number, storeFullName?: string | null, switchResultId: number, transferQuantity: number, store?: { __typename?: 'Store', id: number } | null } | null> | null } };

export type GetAllValidSwitchResultsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllValidSwitchResultsQuery = { __typename?: 'queries', allValidSwitchResults: Array<{ __typename?: 'SwitchResult', id: number, validatedAt?: any | null, user?: { __typename?: 'User', id: number, username?: string | null } | null, config?: { __typename?: 'SwitchConfig', id: number, name?: string | null } | null, metadata?: { __typename?: 'SwitchResultMetadata', id: number, stats?: { __typename?: 'SwitchResulPackageStats', avgRefsPerPackage: number, carbonFootprint?: any | null, globalEstimatedProfit: number, globalEstimatedRevenue: number, id: number, interRegionTransfers: number, numberOfItemSentToWarehouse: number, totalPackagesSent: number, totalProductsSent: number, numberOfProduct: number, globalEstimatedRevenueBenef: number, globalEstimatedProfitBenef: number, storeTransport: number, warehouseTransport: number, totalTransport: number } | null } | null, packages?: Array<{ __typename?: 'SwitchResultPackage', id: number } | null> | null, switchResultStoreSenders?: Array<{ __typename?: 'SwitchResultStoreSender', id: number } | null> | null, switchResultStoreReceivers?: Array<{ __typename?: 'SwitchResultStoreReceiver', id: number } | null> | null } | null> };

export type GetResultOriginConfigQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetResultOriginConfigQuery = { __typename?: 'queries', resultOriginConfig: { __typename?: 'SwitchConfig', id: number, createAt: any, name?: string | null } };

export type GetSwitchSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSwitchSettingQuery = { __typename?: 'queries', switchSetting: { __typename?: 'SwitchSetting', carbonFootPrintEnabled?: boolean | null, centralSizeThreshold?: number | null, co2PerKm?: any | null, productCustomFieldValues1Enabled?: boolean | null, productCustomFieldValues2Enabled?: boolean | null, productCustomFieldValues3Enabled?: boolean | null, productCustomFieldValues4Enabled?: boolean | null, productCustomFieldValues5Enabled?: boolean | null, productDepartementEnabled?: boolean | null, productFamilyEnabled?: boolean | null, productSubFamilyEnabled?: boolean | null, storeCustomFieldValues1Enabled?: boolean | null, storeCustomFieldValues2Enabled?: boolean | null, storeCustomFieldValues3Enabled?: boolean | null, storeCustomFieldValues4Enabled?: boolean | null, storeCustomFieldValues5Enabled?: boolean | null, storeRegionEnabled?: boolean | null, storeTypeEnabled?: boolean | null, transfertDefaultRC?: ReferencyColor | null, transfertDefaultRCT?: ReferencyTransfert | null, transportCostPerItem?: any | null, transportRemovalCost?: number | null, activeProducts?: Array<{ __typename?: 'Product', id: number, code?: string | null, colorCode?: string | null } | null> | null, activeStores?: Array<{ __typename?: 'Store', id: number, code?: string | null, name?: string | null } | null> | null } };

export type GetTenantSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantSettingsQuery = { __typename?: 'queries', tenantSettings: { __typename?: 'TenantSettings', id: number, productCustomFieldName1?: string | null, productCustomFieldName2?: string | null, productCustomFieldName3?: string | null, productCustomFieldName4?: string | null, productCustomFieldName5?: string | null, storeCustomFieldName1?: string | null, storeCustomFieldName2?: string | null, storeCustomFieldName3?: string | null, storeCustomFieldName4?: string | null, storeCustomFieldName5?: string | null, productCustomFieldValues1?: string | null, productCustomFieldValues2?: string | null, productCustomFieldValues3?: string | null, productCustomFieldValues4?: string | null, productCustomFieldValues5?: string | null, storeCustomFieldValues1?: string | null, storeCustomFieldValues2?: string | null, storeCustomFieldValues3?: string | null, storeCustomFieldValues4?: string | null, storeCustomFieldValues5?: string | null } };

export type StoreCustomFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type StoreCustomFieldsQuery = { __typename?: 'queries', storeCustomFields: { __typename?: 'StoreCustomFieldsDto', customFieldName1?: string | null, customFieldValues1?: string | null, customFieldName2?: string | null, customFieldValues2?: string | null, customFieldName3?: string | null, customFieldValues3?: string | null, customFieldName4?: string | null, customFieldValues4?: string | null, customFieldName5?: string | null, customFieldValues5?: string | null } };

export type ProductCustomFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductCustomFieldsQuery = { __typename?: 'queries', productCustomFields: { __typename?: 'ProductCustomFieldsDto', customFieldName1?: string | null, customFieldValues1?: string | null, customFieldName2?: string | null, customFieldValues2?: string | null, customFieldName3?: string | null, customFieldValues3?: string | null, customFieldName4?: string | null, customFieldValues4?: string | null, customFieldName5?: string | null, customFieldValues5?: string | null } };

export type GetProductsListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductsListQuery = { __typename?: 'queries', productsList?: Array<{ __typename?: 'ProductSettingsDto', code?: string | null, name?: string | null, genericReference?: string | null, colorCode?: string | null, colorName?: string | null, universeName?: string | null, seasonName?: string | null, departmentName?: string | null, familyName?: string | null, subFamilyName?: string | null, customFieldValue1?: string | null, customFieldValue2?: string | null, customFieldValue3?: string | null, customFieldValue4?: string | null, customFieldValue5?: string | null, price: any, costPrice: any, articles?: Array<{ __typename?: 'ArticleSettingDto', sKU?: string | null, sizeName?: string | null } | null> | null }> | null };

export type GetStoresSettingQueryVariables = Exact<{
  universeId: Scalars['Int'];
  seasonId?: InputMaybe<Scalars['Int']>;
}>;


export type GetStoresSettingQuery = { __typename?: 'queries', storesSetting?: Array<{ __typename?: 'StoreSettingDto', id: number, name?: string | null, code?: string | null, type?: string | null, targetTurnOver?: any | null, isActive: boolean, address?: { __typename?: 'Address', id: number, addressRegion?: { __typename?: 'AddressRegion', id: number, name?: string | null } | null, country?: { __typename?: 'Country', id: number, name?: string | null } | null } | null }> | null };

export type GetFileImportLogsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFileImportLogsQuery = { __typename?: 'queries', fileImportLogs?: Array<{ __typename?: 'FileImportLog', id: number, importDate: any, object?: string | null, errorsCount: number, isSuccessful: boolean }> | null };

export type GetDashboardInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardInfoQuery = { __typename?: 'queries', dashboard: { __typename?: 'DashboardDto', exportId: number, exportDate: any, newsletterTitle?: string | null, newsletterSubtitle?: string | null, newsletterBody?: string | null, newsletterImgUrl?: string | null, importLogs?: Array<{ __typename?: 'FileImportLog', id: number, importDate: any, object?: string | null, errorsCount: number, isSuccessful: boolean, errors?: string | null } | null> | null } };

export type GetFileImportDetailsQueryVariables = Exact<{
  fileImportLogId: Scalars['Int'];
}>;


export type GetFileImportDetailsQuery = { __typename?: 'queries', fileImportLog: { __typename?: 'FileImportLog', errors?: string | null } };

export type GetViewsStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetViewsStatusQuery = { __typename?: 'queries', viewsStatus: { __typename?: 'RefreshViewsStatus', inProgress: boolean, refreshDate?: any | null } };

export type GetUserSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserSettingsQuery = { __typename?: 'queries', userSettings: { __typename?: 'UserInfoDto', switchAccess: boolean } };


export const CreateSwitchConfigDocument = gql`
    mutation createSwitchConfig($switchConfigInput: SwitchConfigFormInput) {
  createSwitchConfig(switchConfigInput: $switchConfigInput) {
    createAt
    editedAt
    id
    name
  }
}
    `;
export type CreateSwitchConfigMutationFn = Apollo.MutationFunction<CreateSwitchConfigMutation, CreateSwitchConfigMutationVariables>;

/**
 * __useCreateSwitchConfigMutation__
 *
 * To run a mutation, you first call `useCreateSwitchConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSwitchConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSwitchConfigMutation, { data, loading, error }] = useCreateSwitchConfigMutation({
 *   variables: {
 *      switchConfigInput: // value for 'switchConfigInput'
 *   },
 * });
 */
export function useCreateSwitchConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateSwitchConfigMutation, CreateSwitchConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSwitchConfigMutation, CreateSwitchConfigMutationVariables>(CreateSwitchConfigDocument, options);
      }
export type CreateSwitchConfigMutationHookResult = ReturnType<typeof useCreateSwitchConfigMutation>;
export type CreateSwitchConfigMutationResult = Apollo.MutationResult<CreateSwitchConfigMutation>;
export type CreateSwitchConfigMutationOptions = Apollo.BaseMutationOptions<CreateSwitchConfigMutation, CreateSwitchConfigMutationVariables>;
export const DeleteSwitchConfigDocument = gql`
    mutation deleteSwitchConfig($switchConfigIdInput: SwitchConfigIdInput) {
  deleteSwitchConfig(switchConfigIdInput: $switchConfigIdInput) {
    id
  }
}
    `;
export type DeleteSwitchConfigMutationFn = Apollo.MutationFunction<DeleteSwitchConfigMutation, DeleteSwitchConfigMutationVariables>;

/**
 * __useDeleteSwitchConfigMutation__
 *
 * To run a mutation, you first call `useDeleteSwitchConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSwitchConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSwitchConfigMutation, { data, loading, error }] = useDeleteSwitchConfigMutation({
 *   variables: {
 *      switchConfigIdInput: // value for 'switchConfigIdInput'
 *   },
 * });
 */
export function useDeleteSwitchConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSwitchConfigMutation, DeleteSwitchConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSwitchConfigMutation, DeleteSwitchConfigMutationVariables>(DeleteSwitchConfigDocument, options);
      }
export type DeleteSwitchConfigMutationHookResult = ReturnType<typeof useDeleteSwitchConfigMutation>;
export type DeleteSwitchConfigMutationResult = Apollo.MutationResult<DeleteSwitchConfigMutation>;
export type DeleteSwitchConfigMutationOptions = Apollo.BaseMutationOptions<DeleteSwitchConfigMutation, DeleteSwitchConfigMutationVariables>;
export const UpdateSettingsDocument = gql`
    mutation updateSettings($switchSettingInput: SwitchSettingFormInput) {
  updateSettings(switchSettingInput: $switchSettingInput) {
    productFamilyEnabled
  }
}
    `;
export type UpdateSettingsMutationFn = Apollo.MutationFunction<UpdateSettingsMutation, UpdateSettingsMutationVariables>;

/**
 * __useUpdateSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingsMutation, { data, loading, error }] = useUpdateSettingsMutation({
 *   variables: {
 *      switchSettingInput: // value for 'switchSettingInput'
 *   },
 * });
 */
export function useUpdateSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSettingsMutation, UpdateSettingsMutationVariables>(UpdateSettingsDocument, options);
      }
export type UpdateSettingsMutationHookResult = ReturnType<typeof useUpdateSettingsMutation>;
export type UpdateSettingsMutationResult = Apollo.MutationResult<UpdateSettingsMutation>;
export type UpdateSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateSettingsMutation, UpdateSettingsMutationVariables>;
export const ValidateSwitchResultDocument = gql`
    mutation validateSwitchResult($switchResultValidInput: SwitchResultValidInput) {
  validateSwitchResult(switchResultValidInput: $switchResultValidInput) {
    id
  }
}
    `;
export type ValidateSwitchResultMutationFn = Apollo.MutationFunction<ValidateSwitchResultMutation, ValidateSwitchResultMutationVariables>;

/**
 * __useValidateSwitchResultMutation__
 *
 * To run a mutation, you first call `useValidateSwitchResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateSwitchResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateSwitchResultMutation, { data, loading, error }] = useValidateSwitchResultMutation({
 *   variables: {
 *      switchResultValidInput: // value for 'switchResultValidInput'
 *   },
 * });
 */
export function useValidateSwitchResultMutation(baseOptions?: Apollo.MutationHookOptions<ValidateSwitchResultMutation, ValidateSwitchResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateSwitchResultMutation, ValidateSwitchResultMutationVariables>(ValidateSwitchResultDocument, options);
      }
export type ValidateSwitchResultMutationHookResult = ReturnType<typeof useValidateSwitchResultMutation>;
export type ValidateSwitchResultMutationResult = Apollo.MutationResult<ValidateSwitchResultMutation>;
export type ValidateSwitchResultMutationOptions = Apollo.BaseMutationOptions<ValidateSwitchResultMutation, ValidateSwitchResultMutationVariables>;
export const UpdateStoreUniverseActiveDocument = gql`
    mutation updateStoreUniverseActive($storeActiveState: StoreActiveStateInput) {
  updateStoreUniverseActive(storeActiveStateInput: $storeActiveState)
}
    `;
export type UpdateStoreUniverseActiveMutationFn = Apollo.MutationFunction<UpdateStoreUniverseActiveMutation, UpdateStoreUniverseActiveMutationVariables>;

/**
 * __useUpdateStoreUniverseActiveMutation__
 *
 * To run a mutation, you first call `useUpdateStoreUniverseActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStoreUniverseActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStoreUniverseActiveMutation, { data, loading, error }] = useUpdateStoreUniverseActiveMutation({
 *   variables: {
 *      storeActiveState: // value for 'storeActiveState'
 *   },
 * });
 */
export function useUpdateStoreUniverseActiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStoreUniverseActiveMutation, UpdateStoreUniverseActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStoreUniverseActiveMutation, UpdateStoreUniverseActiveMutationVariables>(UpdateStoreUniverseActiveDocument, options);
      }
export type UpdateStoreUniverseActiveMutationHookResult = ReturnType<typeof useUpdateStoreUniverseActiveMutation>;
export type UpdateStoreUniverseActiveMutationResult = Apollo.MutationResult<UpdateStoreUniverseActiveMutation>;
export type UpdateStoreUniverseActiveMutationOptions = Apollo.BaseMutationOptions<UpdateStoreUniverseActiveMutation, UpdateStoreUniverseActiveMutationVariables>;
export const GetRegionsDocument = gql`
    query GetRegions($countries: [Int!]) {
  regions(countries: $countries) {
    id
    name
    depName
    depNum
    country {
      id
      name
      alpha3
    }
  }
}
    `;

/**
 * __useGetRegionsQuery__
 *
 * To run a query within a React component, call `useGetRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionsQuery({
 *   variables: {
 *      countries: // value for 'countries'
 *   },
 * });
 */
export function useGetRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
      }
export function useGetRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
        }
export type GetRegionsQueryHookResult = ReturnType<typeof useGetRegionsQuery>;
export type GetRegionsLazyQueryHookResult = ReturnType<typeof useGetRegionsLazyQuery>;
export type GetRegionsQueryResult = Apollo.QueryResult<GetRegionsQuery, GetRegionsQueryVariables>;
export const GetCountriesDocument = gql`
    query GetCountries {
  countries {
    id
    name
    alpha3
  }
}
    `;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
      }
export function useGetCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export const GetStoreTypesDocument = gql`
    query GetStoreTypes($universeId: Int!, $countries: [Int!], $regions: [Int!]) {
  storeTypes(universeId: $universeId, countries: $countries, regions: $regions) {
    id
    code
    name
    isMain
    isWeb
  }
}
    `;

/**
 * __useGetStoreTypesQuery__
 *
 * To run a query within a React component, call `useGetStoreTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoreTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoreTypesQuery({
 *   variables: {
 *      universeId: // value for 'universeId'
 *      countries: // value for 'countries'
 *      regions: // value for 'regions'
 *   },
 * });
 */
export function useGetStoreTypesQuery(baseOptions: Apollo.QueryHookOptions<GetStoreTypesQuery, GetStoreTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoreTypesQuery, GetStoreTypesQueryVariables>(GetStoreTypesDocument, options);
      }
export function useGetStoreTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoreTypesQuery, GetStoreTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoreTypesQuery, GetStoreTypesQueryVariables>(GetStoreTypesDocument, options);
        }
export type GetStoreTypesQueryHookResult = ReturnType<typeof useGetStoreTypesQuery>;
export type GetStoreTypesLazyQueryHookResult = ReturnType<typeof useGetStoreTypesLazyQuery>;
export type GetStoreTypesQueryResult = Apollo.QueryResult<GetStoreTypesQuery, GetStoreTypesQueryVariables>;
export const GetStoresDocument = gql`
    query GetStores($universeId: Int!, $countries: [Int!], $regions: [Int!], $types: [Int!], $storeCustomField1Codes: [String!], $storeCustomField2Codes: [String!], $storeCustomField3Codes: [String!], $storeCustomField4Codes: [String!], $storeCustomField5Codes: [String!]) {
  stores(
    universeId: $universeId
    countries: $countries
    regions: $regions
    types: $types
    storeCustomField1Codes: $storeCustomField1Codes
    storeCustomField2Codes: $storeCustomField2Codes
    storeCustomField3Codes: $storeCustomField3Codes
    storeCustomField4Codes: $storeCustomField4Codes
    storeCustomField5Codes: $storeCustomField5Codes
  ) {
    id
    code
    name
    storeType {
      id
      code
      name
      isMain
      isWeb
    }
    address {
      id
      address1
      address2
      zipCode
      addressRegion {
        id
        name
        depName
        depNum
      }
      country {
        id
        name
        alpha3
      }
    }
  }
}
    `;

/**
 * __useGetStoresQuery__
 *
 * To run a query within a React component, call `useGetStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoresQuery({
 *   variables: {
 *      universeId: // value for 'universeId'
 *      countries: // value for 'countries'
 *      regions: // value for 'regions'
 *      types: // value for 'types'
 *      storeCustomField1Codes: // value for 'storeCustomField1Codes'
 *      storeCustomField2Codes: // value for 'storeCustomField2Codes'
 *      storeCustomField3Codes: // value for 'storeCustomField3Codes'
 *      storeCustomField4Codes: // value for 'storeCustomField4Codes'
 *      storeCustomField5Codes: // value for 'storeCustomField5Codes'
 *   },
 * });
 */
export function useGetStoresQuery(baseOptions: Apollo.QueryHookOptions<GetStoresQuery, GetStoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoresQuery, GetStoresQueryVariables>(GetStoresDocument, options);
      }
export function useGetStoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoresQuery, GetStoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoresQuery, GetStoresQueryVariables>(GetStoresDocument, options);
        }
export type GetStoresQueryHookResult = ReturnType<typeof useGetStoresQuery>;
export type GetStoresLazyQueryHookResult = ReturnType<typeof useGetStoresLazyQuery>;
export type GetStoresQueryResult = Apollo.QueryResult<GetStoresQuery, GetStoresQueryVariables>;
export const GetSeasonsDocument = gql`
    query GetSeasons {
  seasons {
    id
    code
    name
    isActive
  }
}
    `;

/**
 * __useGetSeasonsQuery__
 *
 * To run a query within a React component, call `useGetSeasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSeasonsQuery(baseOptions?: Apollo.QueryHookOptions<GetSeasonsQuery, GetSeasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSeasonsQuery, GetSeasonsQueryVariables>(GetSeasonsDocument, options);
      }
export function useGetSeasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSeasonsQuery, GetSeasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSeasonsQuery, GetSeasonsQueryVariables>(GetSeasonsDocument, options);
        }
export type GetSeasonsQueryHookResult = ReturnType<typeof useGetSeasonsQuery>;
export type GetSeasonsLazyQueryHookResult = ReturnType<typeof useGetSeasonsLazyQuery>;
export type GetSeasonsQueryResult = Apollo.QueryResult<GetSeasonsQuery, GetSeasonsQueryVariables>;
export const GetUniversesDocument = gql`
    query GetUniverses {
  universes {
    id
    code
    name
  }
}
    `;

/**
 * __useGetUniversesQuery__
 *
 * To run a query within a React component, call `useGetUniversesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniversesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniversesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUniversesQuery(baseOptions?: Apollo.QueryHookOptions<GetUniversesQuery, GetUniversesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUniversesQuery, GetUniversesQueryVariables>(GetUniversesDocument, options);
      }
export function useGetUniversesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUniversesQuery, GetUniversesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUniversesQuery, GetUniversesQueryVariables>(GetUniversesDocument, options);
        }
export type GetUniversesQueryHookResult = ReturnType<typeof useGetUniversesQuery>;
export type GetUniversesLazyQueryHookResult = ReturnType<typeof useGetUniversesLazyQuery>;
export type GetUniversesQueryResult = Apollo.QueryResult<GetUniversesQuery, GetUniversesQueryVariables>;
export const GetDepartmentsDocument = gql`
    query GetDepartments {
  departments {
    id
    code
    name
  }
}
    `;

/**
 * __useGetDepartmentsQuery__
 *
 * To run a query within a React component, call `useGetDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDepartmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetDepartmentsQuery, GetDepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDepartmentsQuery, GetDepartmentsQueryVariables>(GetDepartmentsDocument, options);
      }
export function useGetDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDepartmentsQuery, GetDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDepartmentsQuery, GetDepartmentsQueryVariables>(GetDepartmentsDocument, options);
        }
export type GetDepartmentsQueryHookResult = ReturnType<typeof useGetDepartmentsQuery>;
export type GetDepartmentsLazyQueryHookResult = ReturnType<typeof useGetDepartmentsLazyQuery>;
export type GetDepartmentsQueryResult = Apollo.QueryResult<GetDepartmentsQuery, GetDepartmentsQueryVariables>;
export const GetFamiliesDocument = gql`
    query GetFamilies {
  families {
    id
    code
    name
  }
}
    `;

/**
 * __useGetFamiliesQuery__
 *
 * To run a query within a React component, call `useGetFamiliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFamiliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFamiliesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFamiliesQuery(baseOptions?: Apollo.QueryHookOptions<GetFamiliesQuery, GetFamiliesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFamiliesQuery, GetFamiliesQueryVariables>(GetFamiliesDocument, options);
      }
export function useGetFamiliesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFamiliesQuery, GetFamiliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFamiliesQuery, GetFamiliesQueryVariables>(GetFamiliesDocument, options);
        }
export type GetFamiliesQueryHookResult = ReturnType<typeof useGetFamiliesQuery>;
export type GetFamiliesLazyQueryHookResult = ReturnType<typeof useGetFamiliesLazyQuery>;
export type GetFamiliesQueryResult = Apollo.QueryResult<GetFamiliesQuery, GetFamiliesQueryVariables>;
export const GetSubFamiliesDocument = gql`
    query GetSubFamilies {
  subFamilies {
    id
    code
    name
  }
}
    `;

/**
 * __useGetSubFamiliesQuery__
 *
 * To run a query within a React component, call `useGetSubFamiliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubFamiliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubFamiliesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubFamiliesQuery(baseOptions?: Apollo.QueryHookOptions<GetSubFamiliesQuery, GetSubFamiliesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubFamiliesQuery, GetSubFamiliesQueryVariables>(GetSubFamiliesDocument, options);
      }
export function useGetSubFamiliesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubFamiliesQuery, GetSubFamiliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubFamiliesQuery, GetSubFamiliesQueryVariables>(GetSubFamiliesDocument, options);
        }
export type GetSubFamiliesQueryHookResult = ReturnType<typeof useGetSubFamiliesQuery>;
export type GetSubFamiliesLazyQueryHookResult = ReturnType<typeof useGetSubFamiliesLazyQuery>;
export type GetSubFamiliesQueryResult = Apollo.QueryResult<GetSubFamiliesQuery, GetSubFamiliesQueryVariables>;
export const GetProductsDocument = gql`
    query GetProducts($seasonsIds: [Int!]!, $storeIds: [Int!], $storeTypeIds: [Int!], $storesExpExcludesIds: [Int!], $storesDestExcludesIds: [Int!], $universeId: Int!, $familyIds: [Int!], $subFamilyIds: [Int!], $departmentIds: [Int!], $productCustomField1Codes: [String!], $productCustomField2Codes: [String!], $productCustomField3Codes: [String!], $productCustomField4Codes: [String!], $productCustomField5Codes: [String!], $minPrice: Decimal, $size: WarehouseStock, $sizeComparisionSign: ComparisonSign, $nbPieces: Int, $couvSize: WarehouseStock, $couvSizeComparisionSign: ComparisonSign, $couvNbWeeks: Int, $period: SalePeriod, $fromPeriod: DateTime, $qtyPeriodSign: ComparisonSign, $qtyPeriodNbPiece: Int, $inStoreSign: ComparisonSign, $inStoreNbWeeks: Int, $restockNbWeeks: Int, $markDownPeriodSign: ComparisonSign, $markDownPercent: Int) {
  products(
    seasonsIds: $seasonsIds
    storeIds: $storeIds
    storeTypeIds: $storeTypeIds
    storesExpExcludesIds: $storesExpExcludesIds
    storesDestExcludesIds: $storesDestExcludesIds
    universeId: $universeId
    familyIds: $familyIds
    subFamilyIds: $subFamilyIds
    departmentIds: $departmentIds
    productCustomField1Codes: $productCustomField1Codes
    productCustomField2Codes: $productCustomField2Codes
    productCustomField3Codes: $productCustomField3Codes
    productCustomField4Codes: $productCustomField4Codes
    productCustomField5Codes: $productCustomField5Codes
    minPrice: $minPrice
    size: $size
    sizeComparisionSign: $sizeComparisionSign
    nbPieces: $nbPieces
    couvSize: $couvSize
    couvSizeComparisionSign: $couvSizeComparisionSign
    couvNbWeeks: $couvNbWeeks
    period: $period
    fromPeriod: $fromPeriod
    qtyPeriodSign: $qtyPeriodSign
    qtyPeriodNbPiece: $qtyPeriodNbPiece
    inStoreSign: $inStoreSign
    inStoreNbWeeks: $inStoreNbWeeks
    restockNbWeeks: $restockNbWeeks
    markDownPeriodSign: $markDownPeriodSign
    markDownPercent: $markDownPercent
  ) {
    productId
    colorName
    familyName
    productName
    productPrice
    salesPeriod
    stkStoreVsStkTotal
    stockStore
    storeFlowRate
    theme
    totalFlowRate
    warehouseStock
    productCode
  }
}
    `;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      seasonsIds: // value for 'seasonsIds'
 *      storeIds: // value for 'storeIds'
 *      storeTypeIds: // value for 'storeTypeIds'
 *      storesExpExcludesIds: // value for 'storesExpExcludesIds'
 *      storesDestExcludesIds: // value for 'storesDestExcludesIds'
 *      universeId: // value for 'universeId'
 *      familyIds: // value for 'familyIds'
 *      subFamilyIds: // value for 'subFamilyIds'
 *      departmentIds: // value for 'departmentIds'
 *      productCustomField1Codes: // value for 'productCustomField1Codes'
 *      productCustomField2Codes: // value for 'productCustomField2Codes'
 *      productCustomField3Codes: // value for 'productCustomField3Codes'
 *      productCustomField4Codes: // value for 'productCustomField4Codes'
 *      productCustomField5Codes: // value for 'productCustomField5Codes'
 *      minPrice: // value for 'minPrice'
 *      size: // value for 'size'
 *      sizeComparisionSign: // value for 'sizeComparisionSign'
 *      nbPieces: // value for 'nbPieces'
 *      couvSize: // value for 'couvSize'
 *      couvSizeComparisionSign: // value for 'couvSizeComparisionSign'
 *      couvNbWeeks: // value for 'couvNbWeeks'
 *      period: // value for 'period'
 *      fromPeriod: // value for 'fromPeriod'
 *      qtyPeriodSign: // value for 'qtyPeriodSign'
 *      qtyPeriodNbPiece: // value for 'qtyPeriodNbPiece'
 *      inStoreSign: // value for 'inStoreSign'
 *      inStoreNbWeeks: // value for 'inStoreNbWeeks'
 *      restockNbWeeks: // value for 'restockNbWeeks'
 *      markDownPeriodSign: // value for 'markDownPeriodSign'
 *      markDownPercent: // value for 'markDownPercent'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export const GetSimpleSwitchesConfigsDocument = gql`
    query GetSimpleSwitchesConfigs($isSaved: Boolean, $isPinned: Boolean) {
  switchesConfigs(isSaved: $isSaved, isPinned: $isPinned) {
    id
    name
  }
}
    `;

/**
 * __useGetSimpleSwitchesConfigsQuery__
 *
 * To run a query within a React component, call `useGetSimpleSwitchesConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimpleSwitchesConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimpleSwitchesConfigsQuery({
 *   variables: {
 *      isSaved: // value for 'isSaved'
 *      isPinned: // value for 'isPinned'
 *   },
 * });
 */
export function useGetSimpleSwitchesConfigsQuery(baseOptions?: Apollo.QueryHookOptions<GetSimpleSwitchesConfigsQuery, GetSimpleSwitchesConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimpleSwitchesConfigsQuery, GetSimpleSwitchesConfigsQueryVariables>(GetSimpleSwitchesConfigsDocument, options);
      }
export function useGetSimpleSwitchesConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimpleSwitchesConfigsQuery, GetSimpleSwitchesConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimpleSwitchesConfigsQuery, GetSimpleSwitchesConfigsQueryVariables>(GetSimpleSwitchesConfigsDocument, options);
        }
export type GetSimpleSwitchesConfigsQueryHookResult = ReturnType<typeof useGetSimpleSwitchesConfigsQuery>;
export type GetSimpleSwitchesConfigsLazyQueryHookResult = ReturnType<typeof useGetSimpleSwitchesConfigsLazyQuery>;
export type GetSimpleSwitchesConfigsQueryResult = Apollo.QueryResult<GetSimpleSwitchesConfigsQuery, GetSimpleSwitchesConfigsQueryVariables>;
export const GetSwitchesConfigsDocument = gql`
    query GetSwitchesConfigs($isSaved: Boolean, $isPinned: Boolean) {
  switchesConfigs(isSaved: $isSaved, isPinned: $isPinned) {
    id
    name
    createAt
  }
}
    `;

/**
 * __useGetSwitchesConfigsQuery__
 *
 * To run a query within a React component, call `useGetSwitchesConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSwitchesConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSwitchesConfigsQuery({
 *   variables: {
 *      isSaved: // value for 'isSaved'
 *      isPinned: // value for 'isPinned'
 *   },
 * });
 */
export function useGetSwitchesConfigsQuery(baseOptions?: Apollo.QueryHookOptions<GetSwitchesConfigsQuery, GetSwitchesConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSwitchesConfigsQuery, GetSwitchesConfigsQueryVariables>(GetSwitchesConfigsDocument, options);
      }
export function useGetSwitchesConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSwitchesConfigsQuery, GetSwitchesConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSwitchesConfigsQuery, GetSwitchesConfigsQueryVariables>(GetSwitchesConfigsDocument, options);
        }
export type GetSwitchesConfigsQueryHookResult = ReturnType<typeof useGetSwitchesConfigsQuery>;
export type GetSwitchesConfigsLazyQueryHookResult = ReturnType<typeof useGetSwitchesConfigsLazyQuery>;
export type GetSwitchesConfigsQueryResult = Apollo.QueryResult<GetSwitchesConfigsQuery, GetSwitchesConfigsQueryVariables>;
export const GetSwitchConfigByIdDocument = gql`
    query GetSwitchConfigById($id: Int!) {
  switchConfig(id: $id) {
    productExcludes {
      id
      familyId
      isOnShowcase
      isSynced
      price
      seasonId
      sizeSystemId
    }
    carbonFootprintBonus
    createAt
    editedAt
    id
    interCountry
    interRegion
    maximizationCriterion
    name
    nbDestMax
    nbItemMaxTransfer
    nbItemMaxReceiver
    nbItemMin
    perfDestQtyPeriodSale
    perfDestQtyPeriodSaleSign
    perfExpFlowRatePercent
    perfExpFlowRateSign
    perfExpPresenceMin
    perfExpQtyPeriodSale
    perfExpQtyPeriodSaleSign
    perfIdealStock
    perfIdealStockSender
    pinned
    productCouv
    productCouvSign
    productDepartments {
      id
    }
    productFamilies {
      id
    }
    productFromPeriod
    productInStoreNbWeeks
    productInStoreSign
    productMarkDownPercent
    productMarkDownPeriodSign
    productMinimumPrice
    productNbItem
    productNbWeek
    productQtyPeriodSign
    productQtyPeriodNbItem
    productRestockNbWeeks
    productSalePeriod
    productSeasons {
      id
      isActive
    }
    productSize
    productSizeSign
    productSubFamilies {
      id
    }
    productCustomField1Values
    productCustomField2Values
    productCustomField3Values
    productCustomField4Values
    productCustomField5Values
    universe {
      id
    }
    referencyColor
    referencyTransfert
    saved
    storeCountries {
      id
    }
    storeRecipientExcludes {
      id
    }
    storeRegions {
      id
    }
    storeCustomField1Values
    storeCustomField2Values
    storeCustomField3Values
    storeCustomField4Values
    storeCustomField5Values
    storeSenderExcludes {
      id
    }
    storeTypes {
      id
      isMain
      isWeb
    }
  }
}
    `;

/**
 * __useGetSwitchConfigByIdQuery__
 *
 * To run a query within a React component, call `useGetSwitchConfigByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSwitchConfigByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSwitchConfigByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSwitchConfigByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSwitchConfigByIdQuery, GetSwitchConfigByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSwitchConfigByIdQuery, GetSwitchConfigByIdQueryVariables>(GetSwitchConfigByIdDocument, options);
      }
export function useGetSwitchConfigByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSwitchConfigByIdQuery, GetSwitchConfigByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSwitchConfigByIdQuery, GetSwitchConfigByIdQueryVariables>(GetSwitchConfigByIdDocument, options);
        }
export type GetSwitchConfigByIdQueryHookResult = ReturnType<typeof useGetSwitchConfigByIdQuery>;
export type GetSwitchConfigByIdLazyQueryHookResult = ReturnType<typeof useGetSwitchConfigByIdLazyQuery>;
export type GetSwitchConfigByIdQueryResult = Apollo.QueryResult<GetSwitchConfigByIdQuery, GetSwitchConfigByIdQueryVariables>;
export const GetSwitchConfigFormByIdDocument = gql`
    query GetSwitchConfigFormById($id: Int!) {
  switchConfigForm(id: $id) {
    productExcludesIds
    carbonFootprintBonus
    id
    interCountry
    interRegion
    maximizationCriterion
    name
    nbDestMax
    nbItemMaxTransfer
    nbItemMaxReceiver
    nbItemMin
    perfDestFlowRatePercent
    perfDestFlowRateSign
    perfDestQtyPeriodSale
    perfDestQtyPeriodSaleSign
    perfExpFlowRatePercent
    perfExpFlowRateSign
    perfExpPresenceMin
    perfExpQtyPeriodSale
    perfExpQtyPeriodSaleSign
    perfIdealStock
    perfIdealStockSender
    productCouv
    productCouvSign
    productDepartmentIds
    productFamilyIds
    productFromPeriod
    productInStoreNbWeeks
    productInStoreSign
    productMarkDownPercent
    productMarkDownPeriodSign
    productMinimumPrice
    productNbItem
    productNbWeek
    productQtyPeriodSign
    productQtyPeriodNbItem
    productRestockNbWeeks
    productSalePeriod
    productSeasonsIds
    productSize
    productSizeSign
    productSubFamilyIds
    productCustomField1Values
    productCustomField2Values
    productCustomField3Values
    productCustomField4Values
    productCustomField5Values
    universeId
    referencyColor
    referencyTransfert
    storeCountriesIds
    storeRecipientExcludesIds
    storeRegionsIds
    storeCustomField1Values
    storeCustomField2Values
    storeCustomField3Values
    storeCustomField4Values
    storeCustomField5Values
    storeSenderExcludesIds
    storeTypesIds
    saved
    pinned
  }
}
    `;

/**
 * __useGetSwitchConfigFormByIdQuery__
 *
 * To run a query within a React component, call `useGetSwitchConfigFormByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSwitchConfigFormByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSwitchConfigFormByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSwitchConfigFormByIdQuery(baseOptions: Apollo.QueryHookOptions<GetSwitchConfigFormByIdQuery, GetSwitchConfigFormByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSwitchConfigFormByIdQuery, GetSwitchConfigFormByIdQueryVariables>(GetSwitchConfigFormByIdDocument, options);
      }
export function useGetSwitchConfigFormByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSwitchConfigFormByIdQuery, GetSwitchConfigFormByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSwitchConfigFormByIdQuery, GetSwitchConfigFormByIdQueryVariables>(GetSwitchConfigFormByIdDocument, options);
        }
export type GetSwitchConfigFormByIdQueryHookResult = ReturnType<typeof useGetSwitchConfigFormByIdQuery>;
export type GetSwitchConfigFormByIdLazyQueryHookResult = ReturnType<typeof useGetSwitchConfigFormByIdLazyQuery>;
export type GetSwitchConfigFormByIdQueryResult = Apollo.QueryResult<GetSwitchConfigFormByIdQuery, GetSwitchConfigFormByIdQueryVariables>;
export const GetSimulateSwitchDocument = gql`
    query GetSimulateSwitch($switchConfigId: Int!) {
  simulateSwitch(switchConfigId: $switchConfigId) {
    processId
    processProgress
    processStatus
  }
}
    `;

/**
 * __useGetSimulateSwitchQuery__
 *
 * To run a query within a React component, call `useGetSimulateSwitchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimulateSwitchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimulateSwitchQuery({
 *   variables: {
 *      switchConfigId: // value for 'switchConfigId'
 *   },
 * });
 */
export function useGetSimulateSwitchQuery(baseOptions: Apollo.QueryHookOptions<GetSimulateSwitchQuery, GetSimulateSwitchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimulateSwitchQuery, GetSimulateSwitchQueryVariables>(GetSimulateSwitchDocument, options);
      }
export function useGetSimulateSwitchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimulateSwitchQuery, GetSimulateSwitchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimulateSwitchQuery, GetSimulateSwitchQueryVariables>(GetSimulateSwitchDocument, options);
        }
export type GetSimulateSwitchQueryHookResult = ReturnType<typeof useGetSimulateSwitchQuery>;
export type GetSimulateSwitchLazyQueryHookResult = ReturnType<typeof useGetSimulateSwitchLazyQuery>;
export type GetSimulateSwitchQueryResult = Apollo.QueryResult<GetSimulateSwitchQuery, GetSimulateSwitchQueryVariables>;
export const GetSimulationProgressDocument = gql`
    query GetSimulationProgress($processId: String) {
  simulationProgress(processId: $processId) {
    processId
    processProgress
    processStatus
  }
}
    `;

/**
 * __useGetSimulationProgressQuery__
 *
 * To run a query within a React component, call `useGetSimulationProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimulationProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimulationProgressQuery({
 *   variables: {
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useGetSimulationProgressQuery(baseOptions?: Apollo.QueryHookOptions<GetSimulationProgressQuery, GetSimulationProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimulationProgressQuery, GetSimulationProgressQueryVariables>(GetSimulationProgressDocument, options);
      }
export function useGetSimulationProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimulationProgressQuery, GetSimulationProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimulationProgressQuery, GetSimulationProgressQueryVariables>(GetSimulationProgressDocument, options);
        }
export type GetSimulationProgressQueryHookResult = ReturnType<typeof useGetSimulationProgressQuery>;
export type GetSimulationProgressLazyQueryHookResult = ReturnType<typeof useGetSimulationProgressLazyQuery>;
export type GetSimulationProgressQueryResult = Apollo.QueryResult<GetSimulationProgressQuery, GetSimulationProgressQueryVariables>;
export const StopSimulationDocument = gql`
    query StopSimulation($switchConfigId: Int!, $processId: String) {
  stopSimulation(switchConfigId: $switchConfigId, processId: $processId) {
    processId
  }
}
    `;

/**
 * __useStopSimulationQuery__
 *
 * To run a query within a React component, call `useStopSimulationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStopSimulationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStopSimulationQuery({
 *   variables: {
 *      switchConfigId: // value for 'switchConfigId'
 *      processId: // value for 'processId'
 *   },
 * });
 */
export function useStopSimulationQuery(baseOptions: Apollo.QueryHookOptions<StopSimulationQuery, StopSimulationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StopSimulationQuery, StopSimulationQueryVariables>(StopSimulationDocument, options);
      }
export function useStopSimulationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StopSimulationQuery, StopSimulationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StopSimulationQuery, StopSimulationQueryVariables>(StopSimulationDocument, options);
        }
export type StopSimulationQueryHookResult = ReturnType<typeof useStopSimulationQuery>;
export type StopSimulationLazyQueryHookResult = ReturnType<typeof useStopSimulationLazyQuery>;
export type StopSimulationQueryResult = Apollo.QueryResult<StopSimulationQuery, StopSimulationQueryVariables>;
export const GetSwitchResultsDocument = gql`
    query GetSwitchResults($switchConfigId: Int!, $isSuccess: Boolean, $isProcessed: Boolean) {
  switchResults(
    switchConfigId: $switchConfigId
    isSuccess: $isSuccess
    isProcessed: $isProcessed
  ) {
    config {
      id
    }
    id
    metadata {
      id
      stats {
        avgRefsPerPackage
        carbonFootprint
        globalEstimatedProfit
        globalEstimatedRevenue
        id
        interRegionTransfers
        numberOfItemSentToWarehouse
        totalPackagesSent
        totalProductsSent
        numberOfProduct
        globalEstimatedRevenueBenef
        globalEstimatedProfitBenef
        storeTransport
        warehouseTransport
        totalTransport
      }
    }
    packages {
      id
      items {
        centralSize
        codeCountry
        codeGeo
        codeZone
        colorCode
        costPrice
        genericId
        genericIdWithoutSize
        id
        initSellPrice
        quantity
        sKU
      }
      sender {
        id
        code
        name
      }
      receiver {
        id
        code
        name
      }
    }
    processed
    success
  }
}
    `;

/**
 * __useGetSwitchResultsQuery__
 *
 * To run a query within a React component, call `useGetSwitchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSwitchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSwitchResultsQuery({
 *   variables: {
 *      switchConfigId: // value for 'switchConfigId'
 *      isSuccess: // value for 'isSuccess'
 *      isProcessed: // value for 'isProcessed'
 *   },
 * });
 */
export function useGetSwitchResultsQuery(baseOptions: Apollo.QueryHookOptions<GetSwitchResultsQuery, GetSwitchResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSwitchResultsQuery, GetSwitchResultsQueryVariables>(GetSwitchResultsDocument, options);
      }
export function useGetSwitchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSwitchResultsQuery, GetSwitchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSwitchResultsQuery, GetSwitchResultsQueryVariables>(GetSwitchResultsDocument, options);
        }
export type GetSwitchResultsQueryHookResult = ReturnType<typeof useGetSwitchResultsQuery>;
export type GetSwitchResultsLazyQueryHookResult = ReturnType<typeof useGetSwitchResultsLazyQuery>;
export type GetSwitchResultsQueryResult = Apollo.QueryResult<GetSwitchResultsQuery, GetSwitchResultsQueryVariables>;
export const GetSwitchResultByGuidDocument = gql`
    query GetSwitchResultByGuid($guid: String) {
  switchResultByGuid(guid: $guid) {
    config {
      id
      createAt
    }
    createdAt
    id
    metadata {
      id
      stats {
        avgRefsPerPackage
        carbonFootprint
        globalEstimatedProfit
        globalEstimatedRevenue
        id
        interRegionTransfers
        numberOfItemSentToWarehouse
        totalPackagesSent
        totalProductsSent
        numberOfProduct
        globalEstimatedRevenueBenef
        globalEstimatedProfitBenef
        storeTransport
        warehouseTransport
        totalTransport
      }
    }
    packages {
      id
      items {
        centralSize
        codeCountry
        codeGeo
        codeZone
        colorCode
        costPrice
        genericId
        genericIdWithoutSize
        id
        initSellPrice
        quantity
        sKU
      }
      sender {
        id
        code
        name
      }
      receiver {
        id
        code
        name
      }
    }
    switchResultArticleStores {
      articleSKU
      flow
      gainInSales
      id
      labelColor
      price
      productCode
      productName
      receiverCode
      receiverName
      recipientNeeds
      recipientSales
      recipientStocks
      salesGain
      shipperCode
      shipperName
      shipperSales
      shipperStocks
      size
      switchResultId
      transferQuantity
    }
    switchResultProducts {
      colorLabel
      disable
      gainInSales
      id
      periodSales
      price
      productId
      productCode
      productName
      recipientBreakageRate
      recipientFlowRate
      recipientStock
      salesGain
      salesRecipient
      shipperFlowRate
      shipperSales
      shipperStocks
      stockStore
      storeFlowRate
      switchResultId
      totalflowrate
      transferQuantity
      warehouseStock
      warehouseVsTotalStock
    }
    switchResultStoreSenders {
      disable
      id
      nbTransfert
      salesStoreRecipient
      salesStoreShipper
      stockStoreRecipient
      stockStoreShipper
      store {
        id
      }
      storeFullName
      switchResultId
      transferQuantity
    }
    switchResultStoreReceivers {
      disable
      id
      nbTransfert
      salesStoreRecipient
      salesStoreShipper
      stockStoreRecipient
      stockStoreShipper
      store {
        id
      }
      storeFullName
      switchResultId
      transferQuantity
    }
    processed
    success
  }
}
    `;

/**
 * __useGetSwitchResultByGuidQuery__
 *
 * To run a query within a React component, call `useGetSwitchResultByGuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSwitchResultByGuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSwitchResultByGuidQuery({
 *   variables: {
 *      guid: // value for 'guid'
 *   },
 * });
 */
export function useGetSwitchResultByGuidQuery(baseOptions?: Apollo.QueryHookOptions<GetSwitchResultByGuidQuery, GetSwitchResultByGuidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSwitchResultByGuidQuery, GetSwitchResultByGuidQueryVariables>(GetSwitchResultByGuidDocument, options);
      }
export function useGetSwitchResultByGuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSwitchResultByGuidQuery, GetSwitchResultByGuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSwitchResultByGuidQuery, GetSwitchResultByGuidQueryVariables>(GetSwitchResultByGuidDocument, options);
        }
export type GetSwitchResultByGuidQueryHookResult = ReturnType<typeof useGetSwitchResultByGuidQuery>;
export type GetSwitchResultByGuidLazyQueryHookResult = ReturnType<typeof useGetSwitchResultByGuidLazyQuery>;
export type GetSwitchResultByGuidQueryResult = Apollo.QueryResult<GetSwitchResultByGuidQuery, GetSwitchResultByGuidQueryVariables>;
export const GetAllValidSwitchResultsDocument = gql`
    query GetAllValidSwitchResults {
  allValidSwitchResults {
    id
    validatedAt
    user {
      id
      username
    }
    config {
      id
      name
    }
    metadata {
      id
      stats {
        avgRefsPerPackage
        carbonFootprint
        globalEstimatedProfit
        globalEstimatedRevenue
        id
        interRegionTransfers
        numberOfItemSentToWarehouse
        totalPackagesSent
        totalProductsSent
        numberOfProduct
        globalEstimatedRevenueBenef
        globalEstimatedProfitBenef
        storeTransport
        warehouseTransport
        totalTransport
      }
    }
    packages {
      id
    }
    switchResultStoreSenders {
      id
    }
    switchResultStoreReceivers {
      id
    }
  }
}
    `;

/**
 * __useGetAllValidSwitchResultsQuery__
 *
 * To run a query within a React component, call `useGetAllValidSwitchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllValidSwitchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllValidSwitchResultsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllValidSwitchResultsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllValidSwitchResultsQuery, GetAllValidSwitchResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllValidSwitchResultsQuery, GetAllValidSwitchResultsQueryVariables>(GetAllValidSwitchResultsDocument, options);
      }
export function useGetAllValidSwitchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllValidSwitchResultsQuery, GetAllValidSwitchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllValidSwitchResultsQuery, GetAllValidSwitchResultsQueryVariables>(GetAllValidSwitchResultsDocument, options);
        }
export type GetAllValidSwitchResultsQueryHookResult = ReturnType<typeof useGetAllValidSwitchResultsQuery>;
export type GetAllValidSwitchResultsLazyQueryHookResult = ReturnType<typeof useGetAllValidSwitchResultsLazyQuery>;
export type GetAllValidSwitchResultsQueryResult = Apollo.QueryResult<GetAllValidSwitchResultsQuery, GetAllValidSwitchResultsQueryVariables>;
export const GetResultOriginConfigDocument = gql`
    query GetResultOriginConfig($id: Int!) {
  resultOriginConfig(id: $id) {
    id
    createAt
    name
  }
}
    `;

/**
 * __useGetResultOriginConfigQuery__
 *
 * To run a query within a React component, call `useGetResultOriginConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResultOriginConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResultOriginConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetResultOriginConfigQuery(baseOptions: Apollo.QueryHookOptions<GetResultOriginConfigQuery, GetResultOriginConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResultOriginConfigQuery, GetResultOriginConfigQueryVariables>(GetResultOriginConfigDocument, options);
      }
export function useGetResultOriginConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResultOriginConfigQuery, GetResultOriginConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResultOriginConfigQuery, GetResultOriginConfigQueryVariables>(GetResultOriginConfigDocument, options);
        }
export type GetResultOriginConfigQueryHookResult = ReturnType<typeof useGetResultOriginConfigQuery>;
export type GetResultOriginConfigLazyQueryHookResult = ReturnType<typeof useGetResultOriginConfigLazyQuery>;
export type GetResultOriginConfigQueryResult = Apollo.QueryResult<GetResultOriginConfigQuery, GetResultOriginConfigQueryVariables>;
export const GetSwitchSettingDocument = gql`
    query GetSwitchSetting {
  switchSetting {
    activeProducts {
      id
      code
      colorCode
    }
    activeStores {
      id
      code
      name
    }
    carbonFootPrintEnabled
    centralSizeThreshold
    co2PerKm
    productCustomFieldValues1Enabled
    productCustomFieldValues2Enabled
    productCustomFieldValues3Enabled
    productCustomFieldValues4Enabled
    productCustomFieldValues5Enabled
    productDepartementEnabled
    productFamilyEnabled
    productSubFamilyEnabled
    storeCustomFieldValues1Enabled
    storeCustomFieldValues2Enabled
    storeCustomFieldValues3Enabled
    storeCustomFieldValues4Enabled
    storeCustomFieldValues5Enabled
    storeRegionEnabled
    storeTypeEnabled
    transfertDefaultRC
    transfertDefaultRCT
    transportCostPerItem
    transportRemovalCost
  }
}
    `;

/**
 * __useGetSwitchSettingQuery__
 *
 * To run a query within a React component, call `useGetSwitchSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSwitchSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSwitchSettingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSwitchSettingQuery(baseOptions?: Apollo.QueryHookOptions<GetSwitchSettingQuery, GetSwitchSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSwitchSettingQuery, GetSwitchSettingQueryVariables>(GetSwitchSettingDocument, options);
      }
export function useGetSwitchSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSwitchSettingQuery, GetSwitchSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSwitchSettingQuery, GetSwitchSettingQueryVariables>(GetSwitchSettingDocument, options);
        }
export type GetSwitchSettingQueryHookResult = ReturnType<typeof useGetSwitchSettingQuery>;
export type GetSwitchSettingLazyQueryHookResult = ReturnType<typeof useGetSwitchSettingLazyQuery>;
export type GetSwitchSettingQueryResult = Apollo.QueryResult<GetSwitchSettingQuery, GetSwitchSettingQueryVariables>;
export const GetTenantSettingsDocument = gql`
    query GetTenantSettings {
  tenantSettings {
    id
    productCustomFieldName1
    productCustomFieldName2
    productCustomFieldName3
    productCustomFieldName4
    productCustomFieldName5
    storeCustomFieldName1
    storeCustomFieldName2
    storeCustomFieldName3
    storeCustomFieldName4
    storeCustomFieldName5
    productCustomFieldValues1
    productCustomFieldValues2
    productCustomFieldValues3
    productCustomFieldValues4
    productCustomFieldValues5
    storeCustomFieldValues1
    storeCustomFieldValues2
    storeCustomFieldValues3
    storeCustomFieldValues4
    storeCustomFieldValues5
  }
}
    `;

/**
 * __useGetTenantSettingsQuery__
 *
 * To run a query within a React component, call `useGetTenantSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantSettingsQuery, GetTenantSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantSettingsQuery, GetTenantSettingsQueryVariables>(GetTenantSettingsDocument, options);
      }
export function useGetTenantSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantSettingsQuery, GetTenantSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantSettingsQuery, GetTenantSettingsQueryVariables>(GetTenantSettingsDocument, options);
        }
export type GetTenantSettingsQueryHookResult = ReturnType<typeof useGetTenantSettingsQuery>;
export type GetTenantSettingsLazyQueryHookResult = ReturnType<typeof useGetTenantSettingsLazyQuery>;
export type GetTenantSettingsQueryResult = Apollo.QueryResult<GetTenantSettingsQuery, GetTenantSettingsQueryVariables>;
export const StoreCustomFieldsDocument = gql`
    query StoreCustomFields {
  storeCustomFields {
    customFieldName1
    customFieldValues1
    customFieldName2
    customFieldValues2
    customFieldName3
    customFieldValues3
    customFieldName4
    customFieldValues4
    customFieldName5
    customFieldValues5
  }
}
    `;

/**
 * __useStoreCustomFieldsQuery__
 *
 * To run a query within a React component, call `useStoreCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreCustomFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStoreCustomFieldsQuery(baseOptions?: Apollo.QueryHookOptions<StoreCustomFieldsQuery, StoreCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StoreCustomFieldsQuery, StoreCustomFieldsQueryVariables>(StoreCustomFieldsDocument, options);
      }
export function useStoreCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StoreCustomFieldsQuery, StoreCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StoreCustomFieldsQuery, StoreCustomFieldsQueryVariables>(StoreCustomFieldsDocument, options);
        }
export type StoreCustomFieldsQueryHookResult = ReturnType<typeof useStoreCustomFieldsQuery>;
export type StoreCustomFieldsLazyQueryHookResult = ReturnType<typeof useStoreCustomFieldsLazyQuery>;
export type StoreCustomFieldsQueryResult = Apollo.QueryResult<StoreCustomFieldsQuery, StoreCustomFieldsQueryVariables>;
export const ProductCustomFieldsDocument = gql`
    query ProductCustomFields {
  productCustomFields {
    customFieldName1
    customFieldValues1
    customFieldName2
    customFieldValues2
    customFieldName3
    customFieldValues3
    customFieldName4
    customFieldValues4
    customFieldName5
    customFieldValues5
  }
}
    `;

/**
 * __useProductCustomFieldsQuery__
 *
 * To run a query within a React component, call `useProductCustomFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCustomFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCustomFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductCustomFieldsQuery(baseOptions?: Apollo.QueryHookOptions<ProductCustomFieldsQuery, ProductCustomFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCustomFieldsQuery, ProductCustomFieldsQueryVariables>(ProductCustomFieldsDocument, options);
      }
export function useProductCustomFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCustomFieldsQuery, ProductCustomFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCustomFieldsQuery, ProductCustomFieldsQueryVariables>(ProductCustomFieldsDocument, options);
        }
export type ProductCustomFieldsQueryHookResult = ReturnType<typeof useProductCustomFieldsQuery>;
export type ProductCustomFieldsLazyQueryHookResult = ReturnType<typeof useProductCustomFieldsLazyQuery>;
export type ProductCustomFieldsQueryResult = Apollo.QueryResult<ProductCustomFieldsQuery, ProductCustomFieldsQueryVariables>;
export const GetProductsListDocument = gql`
    query GetProductsList {
  productsList {
    code
    name
    genericReference
    colorCode
    colorName
    universeName
    seasonName
    departmentName
    familyName
    subFamilyName
    customFieldValue1
    customFieldValue2
    customFieldValue3
    customFieldValue4
    customFieldValue5
    price
    costPrice
    articles {
      sKU
      sizeName
    }
  }
}
    `;

/**
 * __useGetProductsListQuery__
 *
 * To run a query within a React component, call `useGetProductsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductsListQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsListQuery, GetProductsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsListQuery, GetProductsListQueryVariables>(GetProductsListDocument, options);
      }
export function useGetProductsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsListQuery, GetProductsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsListQuery, GetProductsListQueryVariables>(GetProductsListDocument, options);
        }
export type GetProductsListQueryHookResult = ReturnType<typeof useGetProductsListQuery>;
export type GetProductsListLazyQueryHookResult = ReturnType<typeof useGetProductsListLazyQuery>;
export type GetProductsListQueryResult = Apollo.QueryResult<GetProductsListQuery, GetProductsListQueryVariables>;
export const GetStoresSettingDocument = gql`
    query GetStoresSetting($universeId: Int!, $seasonId: Int) {
  storesSetting(universeId: $universeId, seasonId: $seasonId) {
    id
    name
    code
    type
    address {
      id
      addressRegion {
        id
        name
      }
      country {
        id
        name
      }
    }
    targetTurnOver
    isActive
  }
}
    `;

/**
 * __useGetStoresSettingQuery__
 *
 * To run a query within a React component, call `useGetStoresSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoresSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoresSettingQuery({
 *   variables: {
 *      universeId: // value for 'universeId'
 *      seasonId: // value for 'seasonId'
 *   },
 * });
 */
export function useGetStoresSettingQuery(baseOptions: Apollo.QueryHookOptions<GetStoresSettingQuery, GetStoresSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoresSettingQuery, GetStoresSettingQueryVariables>(GetStoresSettingDocument, options);
      }
export function useGetStoresSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoresSettingQuery, GetStoresSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoresSettingQuery, GetStoresSettingQueryVariables>(GetStoresSettingDocument, options);
        }
export type GetStoresSettingQueryHookResult = ReturnType<typeof useGetStoresSettingQuery>;
export type GetStoresSettingLazyQueryHookResult = ReturnType<typeof useGetStoresSettingLazyQuery>;
export type GetStoresSettingQueryResult = Apollo.QueryResult<GetStoresSettingQuery, GetStoresSettingQueryVariables>;
export const GetFileImportLogsDocument = gql`
    query GetFileImportLogs {
  fileImportLogs {
    id
    importDate
    object
    errorsCount
    isSuccessful
  }
}
    `;

/**
 * __useGetFileImportLogsQuery__
 *
 * To run a query within a React component, call `useGetFileImportLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileImportLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileImportLogsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFileImportLogsQuery(baseOptions?: Apollo.QueryHookOptions<GetFileImportLogsQuery, GetFileImportLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileImportLogsQuery, GetFileImportLogsQueryVariables>(GetFileImportLogsDocument, options);
      }
export function useGetFileImportLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileImportLogsQuery, GetFileImportLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileImportLogsQuery, GetFileImportLogsQueryVariables>(GetFileImportLogsDocument, options);
        }
export type GetFileImportLogsQueryHookResult = ReturnType<typeof useGetFileImportLogsQuery>;
export type GetFileImportLogsLazyQueryHookResult = ReturnType<typeof useGetFileImportLogsLazyQuery>;
export type GetFileImportLogsQueryResult = Apollo.QueryResult<GetFileImportLogsQuery, GetFileImportLogsQueryVariables>;
export const GetDashboardInfoDocument = gql`
    query GetDashboardInfo {
  dashboard {
    importLogs {
      id
      importDate
      object
      errorsCount
      isSuccessful
      errors
    }
    exportId
    exportDate
    newsletterTitle
    newsletterSubtitle
    newsletterBody
    newsletterImgUrl
  }
}
    `;

/**
 * __useGetDashboardInfoQuery__
 *
 * To run a query within a React component, call `useGetDashboardInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardInfoQuery, GetDashboardInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardInfoQuery, GetDashboardInfoQueryVariables>(GetDashboardInfoDocument, options);
      }
export function useGetDashboardInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardInfoQuery, GetDashboardInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardInfoQuery, GetDashboardInfoQueryVariables>(GetDashboardInfoDocument, options);
        }
export type GetDashboardInfoQueryHookResult = ReturnType<typeof useGetDashboardInfoQuery>;
export type GetDashboardInfoLazyQueryHookResult = ReturnType<typeof useGetDashboardInfoLazyQuery>;
export type GetDashboardInfoQueryResult = Apollo.QueryResult<GetDashboardInfoQuery, GetDashboardInfoQueryVariables>;
export const GetFileImportDetailsDocument = gql`
    query GetFileImportDetails($fileImportLogId: Int!) {
  fileImportLog(fileImportLogId: $fileImportLogId) {
    errors
  }
}
    `;

/**
 * __useGetFileImportDetailsQuery__
 *
 * To run a query within a React component, call `useGetFileImportDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileImportDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileImportDetailsQuery({
 *   variables: {
 *      fileImportLogId: // value for 'fileImportLogId'
 *   },
 * });
 */
export function useGetFileImportDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetFileImportDetailsQuery, GetFileImportDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileImportDetailsQuery, GetFileImportDetailsQueryVariables>(GetFileImportDetailsDocument, options);
      }
export function useGetFileImportDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileImportDetailsQuery, GetFileImportDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileImportDetailsQuery, GetFileImportDetailsQueryVariables>(GetFileImportDetailsDocument, options);
        }
export type GetFileImportDetailsQueryHookResult = ReturnType<typeof useGetFileImportDetailsQuery>;
export type GetFileImportDetailsLazyQueryHookResult = ReturnType<typeof useGetFileImportDetailsLazyQuery>;
export type GetFileImportDetailsQueryResult = Apollo.QueryResult<GetFileImportDetailsQuery, GetFileImportDetailsQueryVariables>;
export const GetViewsStatusDocument = gql`
    query GetViewsStatus {
  viewsStatus {
    inProgress
    refreshDate
  }
}
    `;

/**
 * __useGetViewsStatusQuery__
 *
 * To run a query within a React component, call `useGetViewsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewsStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetViewsStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetViewsStatusQuery, GetViewsStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetViewsStatusQuery, GetViewsStatusQueryVariables>(GetViewsStatusDocument, options);
      }
export function useGetViewsStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewsStatusQuery, GetViewsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetViewsStatusQuery, GetViewsStatusQueryVariables>(GetViewsStatusDocument, options);
        }
export type GetViewsStatusQueryHookResult = ReturnType<typeof useGetViewsStatusQuery>;
export type GetViewsStatusLazyQueryHookResult = ReturnType<typeof useGetViewsStatusLazyQuery>;
export type GetViewsStatusQueryResult = Apollo.QueryResult<GetViewsStatusQuery, GetViewsStatusQueryVariables>;
export const GetUserSettingsDocument = gql`
    query GetUserSettings {
  userSettings {
    switchAccess
  }
}
    `;

/**
 * __useGetUserSettingsQuery__
 *
 * To run a query within a React component, call `useGetUserSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserSettingsQuery, GetUserSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserSettingsQuery, GetUserSettingsQueryVariables>(GetUserSettingsDocument, options);
      }
export function useGetUserSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSettingsQuery, GetUserSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserSettingsQuery, GetUserSettingsQueryVariables>(GetUserSettingsDocument, options);
        }
export type GetUserSettingsQueryHookResult = ReturnType<typeof useGetUserSettingsQuery>;
export type GetUserSettingsLazyQueryHookResult = ReturnType<typeof useGetUserSettingsLazyQuery>;
export type GetUserSettingsQueryResult = Apollo.QueryResult<GetUserSettingsQuery, GetUserSettingsQueryVariables>;